(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3432],{

/***/ 66607:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),

/***/ 50142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SSOLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _COMPONENTS_common_commonUtil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72425);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






function SSOLink(_param) {
    var href = _param.href, onClick = _param.onClick, children = _param.children, _target = _param.target, target = _target === void 0 ? "_self" : _target, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "href",
        "onClick",
        "children",
        "target"
    ]);
    var handleClick = function(e) {
        e.preventDefault();
        // 기존 클릭 이벤트 실행
        if (onClick) onClick(e);
        // SSO 처리 후 리다이렉트
        (0,_COMPONENTS_common_commonUtil__WEBPACK_IMPORTED_MODULE_1__/* .getSSOUrl */ .jq)(href).then(function(redirectUrl) {
            window.open(redirectUrl, target);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        href: href,
        onClick: handleClick
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 37875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@yb/styled-px2rem/esm/index.esm.js
var index_esm = __webpack_require__(53842);
;// CONCATENATED MODULE: ./framework/ui/mobile/footer/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 15px;\n	background-color: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	nav ul {\n		display: grid;\n		grid-template-columns: 0.34fr 0.34fr 0.34fr;\n		grid-template-rows: 50px 50px;\n		border-top: 1px solid var(--line-color);\n		li {\n			background-color: #f5f5f5;\n			border-bottom: 1px solid var(--line-color);\n			height: 50px;\n			box-sizing: border-box;\n			&:not(:nth-child(3n)) {\n				border-right: 1px solid var(--line-color);\n			}\n			a {\n				display: flex;\n				align-items: center;\n				justify-content: center;\n				text-align: center;\n				width: 100%;\n				height: 100%;\n				line-height: 1.3;\n				color: #111;\n				word-break: break-all;\n			}\n		}\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-wrap: wrap;\n	gap: 15px;\n	padding: 0 15px;\n	margin: 30px 0 20px;\n	a {\n		line-height: 1;\n		font-size: 12px;\n		color: var(--gray-color);\n		span {\n			color: #4567ad;\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 10px;\n	align-items: center;\n	justify-content: flex-start;\n	padding: 0 15px;\n	margin-bottom: 30px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: block;\n	overflow: hidden;\n	width: 36px;\n	height: 36px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/footer/btn_sns_m.png) no-repeat;\n	background-size: auto 100%;\n	font-size: 0;\n	color: transparent;\n	background-position: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: flex-start;\n	align-items: center;\n	gap: 10px;\n	padding: 0 15px;\n	margin: 0 0 20px;\n	img {\n		display: inline-block;\n		width: 125px;\n		height: 10px;\n		vertical-align: baseline;\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: flex;\n	flex-wrap: wrap;\n	gap: 10px;\n	justify-content: flex-start;\n	align-items: center;\n	line-height: 1;\n	padding-left: 0;\n	padding-right: 20px;\n	font-size: 15px;\n	font-family: "PT-medium";\n	font-weight: bold;\n	color: #111;\n	&:after {\n		position: absolute;\n		top: 1px;\n		right: 0px;\n		width: 6px;\n		height: 6px;\n		border-top: 1px solid #111;\n		border-right: 1px solid #111;\n		transform: translateY(0px) rotate(135deg);\n		content: "";\n\n		',
        "\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 0 15px;\n	font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 10px;\n	> div {\n		line-height: 1.5;\n		&:nth-of-type(3) {\n			display: flex;\n			flex-wrap: wrap;\n			gap: 10px 20px;\n		}\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	span {\n		position: relative;\n		margin-top: 0;\n		&:after {\n			display: inline-block;\n			width: 1px;\n			height: 10px;\n			margin: 0 6px;\n			background: var(--line-color);\n			content: "";\n		}\n	}\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1.8;\n	margin-left: 10px;\n	font-size: 10px;\n	text-decoration: underline;\n	color: #111;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	margin-top: 15px;\n	justify-content: flex-start;\n	> div {\n		width: 100%;\n		> a {\n			display: inline-block;\n			margin-bottom: 12px;\n			font-size: 13px;\n			font-family: "PT-medium";\n			font-weight: bold;\n			color: #111;\n			&:after {\n				display: inline-block;\n				margin: 0px 0px 1px 10px;\n				width: 7px;\n				height: 7px;\n				border-top: 1px solid #111;\n				border-left: 1px solid #111;\n				transform: rotate(135deg);\n				box-sizing: border-box;\n				pointer-events: none;\n				content: "";\n			}\n		}\n	}\n	li {\n		display: flex;\n		gap: 10px;\n		width: 100%;\n		line-height: 1;\n		p {\n			min-width: 90px;\n			color: var(--gray-color);\n		}\n		span > a {\n			color: #111;\n		}\n		+ li {\n			margin-top: 8px;\n		}\n	}\n'
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 15px 0 20px;\n	li {\n		line-height: 1;\n		&:last-child {\n			margin-bottom: 0;\n		}\n		+ li {\n			margin-top: 7px;\n		}\n	}\n	span {\n		display: inline-block;\n		/* width: 60px; */\n		color: var(--gray-color);\n	}\n	a {\n		margin-left: 4px;\n		text-decoration: underline;\n		border-bottom: none;\n		color: var(--gray-color);\n		letter-spacing: 0;\n	}\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	padding: 0 15px;\n	li {\n		position: relative;\n		padding-left: 8px;\n		font-size: 12px;\n		line-height: 1.5;\n		color: var(--gray-color);\n		word-break: keep-all;\n		&:not(:first-of-type) {\n			margin-top: 12px;\n		}\n		&:before {\n			position: absolute;\n			top: 7px;\n			left: 0;\n			width: 3px;\n			height: 3px;\n			border-radius: 50%;\n			background: #c0c0c0;\n			content: " ";\n		}\n		> a {\n			position: relative;\n			margin-left: 5px;\n			font-size: 12px;\n			text-decoration: underline;\n			color: #777;\n			&:after {\n				position: absolute;\n				top: 50%;\n				left: 100%;\n				width: 4px;\n				height: 4px;\n				margin: -2px 0 0 3px;\n				border-top: 1px solid #777;\n				border-right: 1px solid #777;\n				transform: rotate(45deg);\n				content: " ";\n			}\n		}\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding-left: 15px;\n	margin: 10px 0 40px;\n	font-size: 12px;\n	text-align: left;\n	line-height: 1;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	gap: 10px;\n	li {\n		&:nth-child(2) {\n			a {\n				&::before {\n					width: 50px;\n					background-position: -55px 0;\n				}\n			}\n		}\n		a {\n			display: block;\n			width: 100%;\n			height: 100%;\n			&::before {\n				display: block;\n				width: 55px;\n				height: 47px;\n				background-image: url(https://cimgcdn.ybtour.co.kr/common/footer/logo_franchise.png);\n				background-size: auto 47px;\n				background-position: 0 0;\n				background-repeat: no-repeat;\n				content: "";\n			}\n		}\n		span {\n			position: absolute;\n			width: 1px;\n			height: 1px !important;\n			padding: 0;\n			margin: -1px;\n			border: none;\n			clip: rect(0 0 0 0);\n			overflow: hidden;\n		}\n	}\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}



var FooterWrap = index_esm/* default.footer */.ZP.footer(_templateObject());
var Fnb = index_esm/* default.section */.ZP.section(_templateObject1());
var LinkWrap = index_esm/* default.section */.ZP.section(_templateObject2());
var Policies = index_esm/* default.div */.ZP.div(_templateObject3());
var Sns = index_esm/* default.div */.ZP.div(_templateObject4());
var SnsItem = index_esm/* default.a */.ZP.a(_templateObject5(), function(props) {
    if (props.sns === "facebook") {
        return "\n                0 0;\n            ";
    }
    if (props.sns === "instagram") {
        return "\n				-36px 0;\n            ";
    }
    if (props.sns === "youtube") {
        return "\n				-72px 0;\n            ";
    }
    if (props.sns === "kakao") {
        return "\n				-108px 0;\n            ";
    }
    if (props.sns === "blog") {
        return "\n				-144px 0;\n            ";
    }
    if (props.sns === "post") {
        return "\n				-180px 0;\n            ";
    }
});
var Corporation = index_esm/* default.div */.ZP.div(_templateObject6());
var ToggleBtn = index_esm/* default.button */.ZP.button(_templateObject7(), function(props) {
    return props.$isActive && "\n			transform: translateY(5px) rotate(315deg);\n		";
});
var ToggleBox = index_esm/* default.article */.ZP.article(_templateObject8());
var CompanyArea = index_esm/* default.div */.ZP.div(_templateObject9());
var Yb = index_esm/* default.address */.ZP.address(_templateObject10());
var TxtLink = index_esm/* default.a */.ZP.a(_templateObject11());
var CsArea = index_esm/* default.div */.ZP.div(_templateObject12());
var MailArea = index_esm/* default.ul */.ZP.ul(_templateObject13());
var ExplainList = index_esm/* default.ul */.ZP.ul(_templateObject14());
var Copyright = index_esm/* default.p */.ZP.p(_templateObject15());
var LogoList = index_esm/* default.ul */.ZP.ul(_templateObject16());
var Footer = function() {
    var ref = useState(false), isActive = ref[0], setIsActive = ref[1];
    return /*#__PURE__*/ _jsxs(FooterWrap, {
        children: [
            /*#__PURE__*/ _jsx(Fnb, {
                children: /*#__PURE__*/ _jsx("nav", {
                    children: /*#__PURE__*/ _jsxs("ul", {
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/cs/main.yb",
                                    children: "고객센터"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/cs/noticeList.yb",
                                    children: "공지사항"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/cs/faqList.yb",
                                    children: "자주하는질문"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/cs/qnaGuide.yb",
                                    children: "1:1문의"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/cs/estimateWrite.yb",
                                    children: "견적문의"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/eplg/episodeList.yb",
                                    children: "여행후기"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/cs/praiseList.yb",
                                    children: "칭찬합시다"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/cs/freeInstallmentPopup.yb",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "무이자할부"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://mpkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=",
                                    target: "_self",
                                    children: "현금영수증"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(LinkWrap, {
                children: [
                    /*#__PURE__*/ _jsxs(Policies, {
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: "https://company.ybtour.co.kr/",
                                children: "회사소개"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "https://mpkg.ybtour.co.kr/common/privacy.yb",
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: "개인정보처리방침"
                                })
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "https://mpkg.ybtour.co.kr/common/internetAgree.yb",
                                children: "이용약관"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "https://mpkg.ybtour.co.kr/common/travelAgree.yb",
                                children: "여행약관"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "https://mpkg.ybtour.co.kr/common/travelerInsuInfo.yb",
                                children: "여행자보험"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "https://company.ybtour.co.kr/agent/about",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "대리점안내"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Sns, {
                        children: [
                            /*#__PURE__*/ _jsx(SnsItem, {
                                sns: "facebook",
                                href: "https://www.facebook.com/yellowballoonofficial/",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "페이스북"
                            }),
                            /*#__PURE__*/ _jsx(SnsItem, {
                                sns: "instagram",
                                href: "https://www.instagram.com/yellowballoon_official",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "인스타그램"
                            }),
                            /*#__PURE__*/ _jsx(SnsItem, {
                                sns: "youtube",
                                href: "https://www.youtube.com/user/ybtour2013",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "유튜브"
                            }),
                            /*#__PURE__*/ _jsx(SnsItem, {
                                sns: "kakao",
                                href: "https://pf.kakao.com/_hhAxbd",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "카카오톡"
                            }),
                            /*#__PURE__*/ _jsx(SnsItem, {
                                sns: "blog",
                                href: "http://m.blog.naver.com/yb_tour",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "네이버 블로그"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("section", {
                children: [
                    /*#__PURE__*/ _jsx(Corporation, {
                        children: /*#__PURE__*/ _jsxs(ToggleBtn, {
                            type: "button",
                            onClick: function() {
                                return setIsActive(!isActive);
                            },
                            $isActive: isActive,
                            children: [
                                "(주)노랑풍선",
                                /*#__PURE__*/ _jsx("img", {
                                    src: "https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png",
                                    alt: "KOSDAQ 코스닥 상장법인"
                                })
                            ]
                        })
                    }),
                    isActive && /*#__PURE__*/ _jsxs(ToggleBox, {
                        children: [
                            /*#__PURE__*/ _jsxs(CompanyArea, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsxs(Yb, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "대표이사 김진국"
                                                    }),
                                                    "서울특별시 중구 수표로 31, 노랑풍선빌딩"
                                                ]
                                            }),
                                            "사업자등록번호 104-81-64440",
                                            /*#__PURE__*/ _jsx(TxtLink, {
                                                href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "사업자 정보확인"
                                            }),
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "관광사업자등록증번호 제2006-000003호",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "통신판매업신고번호 제2008-서울중구-0278"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("address", {
                                                children: [
                                                    "[부산지사] 부산광역시 부산진구 중앙대로668, 9층 912호 ",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    "(부전동, 에이원프라자)"
                                                ]
                                            }),
                                            "사업자등록번호 870-85-01900"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("p", {
                                                children: [
                                                    "영업배상책임보험: 총 20억원",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    "공제영업보증가입: 15억 1천만원",
                                                    /*#__PURE__*/ _jsx("br", {}),
                                                    "공제기획 여행보증: 7억원"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(LogoList, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "http://tourinfo.or.kr/standard/partners.asp",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                children: "국외여행상품 정보제공 표준안 참여 여행사"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("li", {
                                                        children: /*#__PURE__*/ _jsx("a", {
                                                            href: "https://pkg.ybtour.co.kr/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd= ",
                                                            target: "_self",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                children: "현금영수증 의무발행 가맹점"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(CsArea, {
                                children: /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("a", {
                                            href: "https://mpkg.ybtour.co.kr/cs/main.yb",
                                            children: "고객센터"
                                        }),
                                        /*#__PURE__*/ _jsxs("ul", {
                                            children: [
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "패키지여행 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                href: "tel:15442288",
                                                                children: "1544-2288"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "자유여행 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                href: "tel:16443399",
                                                                children: "1644-3399"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("li", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "부산/지방출발 상담"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                href: "tel:0517130710",
                                                                children: "051-713-0710"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(MailArea, {
                                children: [
                                    /*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "대표메일"
                                            }),
                                            /*#__PURE__*/ _jsx("a", {
                                                href: "mailto:master@ybtour.com",
                                                children: "master@ybtour.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "마케팅제휴"
                                            }),
                                            /*#__PURE__*/ _jsx("a", {
                                                href: "mailto:marketing@ybtour.com",
                                                children: "marketing@ybtour.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "판매제휴"
                                            }),
                                            /*#__PURE__*/ _jsx("a", {
                                                href: "mailto:salespartner@ybtour.com",
                                                children: "salespartner@ybtour.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "대리점문의"
                                            }),
                                            /*#__PURE__*/ _jsx("a", {
                                                href: "mailto:sales.agent@ybtour.co.kr",
                                                children: "sales.agent@ybtour.co.kr"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(ExplainList, {
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: "노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다. 따라서 해당 상품의 상품\xb7거래정보 및 거래 등에 대하여 책임을 지지 않습니다."
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: "항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된 가격이며, 유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다."
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: "노랑풍선의 '예금주' 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다."
                            }),
                            /*#__PURE__*/ _jsxs("li", {
                                children: [
                                    "고객님의 안전하고 편안한 여행을 위해 꼭 알아두셔야 할 여행 안전 유의사항을 확인해주세요.",
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "https://mpkg.ybtour.co.kr/cs/travelSafetyGuide.yb",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "자세히보기"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Copyright, {
                        children: "Ⓒ Yellow Balloon tour. All Rights Reserved."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footer = ((/* unused pure expression or super */ null && (Footer)));


// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./components/common/ssoLink/index.tsx
var ssoLink = __webpack_require__(50142);
;// CONCATENATED MODULE: ./components/layout/footer/Mobile/index.tsx





var Mobile_Footer = function() {
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    var handleClick = function() {
        setIsActive(!isActive);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fnb, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/main.yb"),
                                    children: "고객센터"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/noticeList.yb"),
                                    children: "공지사항"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/faqList.yb"),
                                    children: "자주하는질문"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/qnaGuide.yb"),
                                    children: "1:1문의"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/estimateWrite.yb"),
                                    children: "견적문의"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/eplg/episodeList.yb"),
                                    children: "여행후기"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/praiseList.yb"),
                                    children: "칭찬합시다"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/freeInstallmentPopup.yb"),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "무이자할부"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                    href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd="),
                                    target: "_self",
                                    children: "현금영수증"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Policies, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                href: config_public/* default.ENV_COMPANY_URL */.Z.ENV_COMPANY_URL,
                                children: "회사소개"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/common/privacy.yb"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "개인정보처리방침"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/common/internetAgree.yb"),
                                children: "이용약관"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/common/travelAgree.yb"),
                                children: "여행약관"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/common/travelerInsuInfo.yb"),
                                children: "여행자보험"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                href: "".concat(config_public/* default.ENV_COMPANY_URL */.Z.ENV_COMPANY_URL, "/agent/about"),
                                target: "_blank",
                                rel: "noreferrer",
                                children: "대리점안내"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Sns, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                sns: "facebook",
                                href: "https://www.facebook.com/yellowballoonofficial/",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "페이스북"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                sns: "instagram",
                                href: "https://www.instagram.com/yellowballoon_official",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "인스타그램"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                sns: "youtube",
                                href: "https://www.youtube.com/user/ybtour2013",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "유튜브"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                sns: "kakao",
                                href: "https://pf.kakao.com/_hhAxbd",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "카카오톡"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnsItem, {
                                sns: "blog",
                                href: "http://m.blog.naver.com/yb_tour",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "네이버 블로그"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Corporation, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleBtn, {
                            type: "button",
                            onClick: handleClick,
                            $isActive: isActive,
                            children: [
                                "(주)노랑풍선",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png",
                                    alt: "KOSDAQ 코스닥 상장법인"
                                })
                            ]
                        })
                    }),
                    isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyArea, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Yb, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "대표이사 김진국"
                                                    }),
                                                    "서울특별시 중구 수표로 31, 노랑풍선빌딩"
                                                ]
                                            }),
                                            "사업자등록번호 104-81-64440",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TxtLink, {
                                                href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "사업자 정보확인"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "관광사업자등록증번호 제2006-000003호",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "통신판매업신고번호 제2008-서울중구-0278"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                                children: [
                                                    "[부산지사] 부산광역시 부산진구 중앙대로668, 9층 912호 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "(부전동, 에이원프라자)"
                                                ]
                                            }),
                                            "사업자등록번호 870-85-01900"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "영업배상책임보험: 총 20억원",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "공제영업보증가입: 15억 1천만원",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "공제기획 여행보증: 7억원"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: "http://tourinfo.or.kr/standard/partners.asp",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "국외여행상품 정보제공 표준안 참여 여행사"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                                            href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd="),
                                                            target: "_self",
                                                            rel: "noreferrer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "현금영수증 의무발행 가맹점"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsArea, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                            href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/cs/main.yb"),
                                            children: "고객센터"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "패키지여행 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "tel:15442288",
                                                                children: "1544-2288"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "자유여행 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "tel:16443399",
                                                                children: "1644-3399"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "부산/지방출발 상담"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "tel:0517130710",
                                                                children: "051-713-0710"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MailArea, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "대표메일"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:master@ybtour.com",
                                                children: "master@ybtour.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "마케팅제휴"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:marketing@ybtour.com",
                                                children: "marketing@ybtour.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "판매제휴"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:salespartner@ybtour.com",
                                                children: "salespartner@ybtour.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "대리점문의"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:sales.agent@ybtour.co.kr",
                                                children: "sales.agent@ybtour.co.kr"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExplainList, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다. 따라서 해당 상품의 상품\xb7거래정보 및 거래 등에 대하여 책임을 지지 않습니다."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된 가격이며, 유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "노랑풍선의 '예금주' 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여 당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선 고객센터로 문의하거나 신고하여 주시기 바랍니다."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "고객님의 안전하고 편안한 여행을 위해 꼭 알아두셔야 할 여행 안전 유의사항을 확인해주세요.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                                        href: "https://mpkg.ybtour.co.kr/cs/travelSafetyGuide.yb",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "자세히보기"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright, {
                        children: "Ⓒ Yellow Balloon tour. All Rights Reserved."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Mobile = (Mobile_Footer);


/***/ }),

/***/ 62499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header_Mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./components/common/modal/share/Mobile.tsx + 3 modules
var Mobile = __webpack_require__(82864);
// EXTERNAL MODULE: ./components/hoc/withWishList.tsx
var withWishList = __webpack_require__(40198);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./components/style/common/categoryToastM.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	left: 0;\n	right: 0;\n	bottom: 0;\n	z-index: 100;\n	width: 100%;\n	height: 100%;\n	animation: ",
        ";\n	overscroll-behavior: contain;\n\n	",
        ";\n\n	> div {\n		animation: ",
        ";\n	}\n\n	@keyframes fade-in {\n		0% {\n			background-color: rgba(0, 0, 0, 0);\n		}\n		100% {\n			background-color: rgba(0, 0, 0, 0.6);\n		}\n	}\n	@keyframes fade-out {\n		0% {\n			background-color: rgba(0, 0, 0, 0.6);\n		}\n		100% {\n			background-color: rgba(0, 0, 0, 0);\n		}\n	}\n\n	@keyframes toast-up {\n		0% {\n			transform: translateY(100%);\n		}\n		100% {\n			transform: translateY(0);\n		}\n	}\n	@keyframes toast-down {\n		0% {\n			transform: translateY(0);\n		}\n		100% {\n			transform: translateY(100%);\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	right: 0;\n	left: 0;\n	bottom: 0;\n	z-index: 100;\n	width: 100%;\n	height: 100%;\n	background-color: transparent;\n	opacity: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	left: 0;\n	bottom: 0;\n	z-index: 101;\n	width: 100%;\n	min-height: 120px;\n	/* height: calc(100vh - 120px); */\n	box-sizing: border-box;\n	background-color: #fff;\n	border-radius: 15px 15px 0 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	flex: 0 0 50px;\n	width: 100%;\n	height: 50px;\n	padding: 0 15px;\n	border-bottom: 1px solid var(--line-color);\n	box-sizing: border-box;\n	> h3 {\n		line-height: 1;\n		font-size: 17px;\n		font-family: "PT-medium";\n		color: #111;\n	}\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	right: 15px;\n	width: 18px;\n	height: 18px;\n	padding: 0;\n	background-color: transparent;\n	&::before,\n	&:after {\n		position: absolute;\n		top: 50%;\n		left: 50%;\n		display: block;\n		width: 2px;\n		height: 24px;\n		transform: translate(-50%, -50%) rotate(135deg);\n		background-color: #231f20;\n		border-radius: 4px;\n		content: "";\n	}\n	&::after {\n		width: 24px;\n		height: 2px;\n	}\n'
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 100%;\n	padding: 30px 15px 0;\n	box-sizing: border-box;\n	overflow-y: hidden;\n\n	> ul {\n		display: flex;\n		flex-direction: column;\n		gap: 20px;\n		height: calc(100vh - 300px);\n		padding-bottom: 50px;\n		box-sizing: border-box;\n		overflow-y: auto;\n		overflow-x: hidden;\n		> li {\n			width: 100%;\n			height: 20px;\n		}\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	gap: 9px;\n	width: 100%;\n	input[type="radio"] {\n		position: relative;\n		flex: 0 0 auto;\n		width: 20px;\n		height: 20px;\n		padding: 0;\n		border-radius: 100%;\n		background-color: #fff;\n		cursor: pointer;\n		&:before {\n			position: absolute;\n			top: 50%;\n			left: 50%;\n			width: 0;\n			height: 0;\n			border-radius: 50%;\n			transform: translate(-50%, -50%);\n			content: "";\n			cursor: pointer;\n			transition: all 250ms ease;\n			box-sizing: border-box;\n		}\n		&:focus:not(:disabled) {\n			border: 1px solid #111;\n			outline: none;\n		}\n		&:active:not(:disabled) {\n			border: 1px solid #111;\n			&:checked {\n				border: 1px solid #111;\n				background-color: #111;\n				&:before {\n					background-color: #111;\n				}\n			}\n		}\n		&:checked {\n			border: 1px solid #111;\n			background-color: #fff;\n			&:before {\n				width: 10px;\n				height: 10px;\n				background-color: #111;\n			}\n			+ label {\n				color: #111;\n				font-family: "PT-medium";\n			}\n		}\n		&:disabled {\n			border-color: var(--line-color);\n			background-color: var(--disabled-color);\n			cursor: initial;\n			&:before {\n				background-color: #999;\n				cursor: initial;\n			}\n			+ label {\n				color: #999;\n				cursor: initial;\n			}\n		}\n	}\n	label {\n		width: 100%;\n		line-height: 1;\n		font-size: 14px;\n		color: #555;\n		cursor: pointer;\n	}\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var PopupWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-56569925-0"
})(_templateObject(), function(props) {
    return props.animate ? "fade-in 0.25s forwards" : "fade-out 0.25s forwards";
}, function(props) {
    return props.show ? "\n		display: block;\n	" : "\n		display: none;\n	";
}, function(props) {
    return props.animate ? "toast-up 0.25s forwards" : "toast-down 0.25s forwards";
});
var PopupDimm = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-56569925-1"
})(_templateObject1());
var PopupContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-56569925-2"
})(_templateObject2());
var PopupHeader = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-56569925-3"
})(_templateObject3());
var PopupCloseButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-56569925-4"
})(_templateObject4());
var PopupArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-56569925-5"
})(_templateObject5());
var RadioWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-56569925-6"
})(_templateObject6());


// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalMenu.ts
var useGlobalMenu = __webpack_require__(98653);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/layout/header/Mobile/Category.tsx








var Category = function(overlayProps) {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    /** 메뉴 관련 */ var globalMenu = (ref = (0,useGlobalMenu/* default */.Z)().data) === null || ref === void 0 ? void 0 : ref.body;
    var menuLv2List = globalMenu.menuLv2List, menuLv3List = globalMenu.menuLv3List;
    var menu = (0,_to_consumable_array/* default */.Z)(menuLv2List).concat((0,_to_consumable_array/* default */.Z)(menuLv3List));
    var queryDspSid = ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.dspSid) || "";
    var dspSidHi = ((ref2 = menu.find(function(o) {
        return o.dspSid === queryDspSid;
    })) === null || ref2 === void 0 ? void 0 : ref2.dspSidHi) || "";
    // lv3List
    var categoryList = menu.filter(function(o) {
        return o.dspSidHi === dspSidHi && o.mobileYn === "Y";
    });
    var lv2DspNm = menuLv2List.find(function(o) {
        return o.dspSid === dspSidHi;
    }).dspNm || "";
    /** publish */ var ref3 = (0,react.useState)(true), show = ref3[0], setShow = ref3[1];
    var ref4 = (0,react.useState)(show), animate = ref4[0], setAnimate = ref4[1];
    var wrapRef = (0,react.useRef)(null);
    var popupClose = function() {
        setShow(false);
    };
    (0,react.useEffect)(function() {
        if (!animate && wrapRef.current) {
            wrapRef.current.addEventListener("animationend", popupClose);
            return function() {
                if (!animate && wrapRef.current) {
                    wrapRef.current.removeEventListener("animationend", popupClose);
                }
            };
        }
    }, [
        show,
        animate,
        wrapRef
    ]);
    (0,react.useEffect)(function() {
        if (show && document.body) {
            document.body.style.overflowY = "hidden";
            document.body.style.touchAction = "none";
        }
        return function() {
            document.body.style.removeProperty("overflow-y");
            document.body.style.removeProperty("touch-action");
        };
    }, [
        show
    ]);
    var handleClick = function(mdspUrl, mwebMenuTarget) {
        var target = (0,commonUtil/* getTarget */.U9)(mwebMenuTarget);
        if (ybutil_cjs/* device.isYBApp */.Uh.isYBApp() && target === "_blank") {
            var encodedUrl = encodeURIComponent(mdspUrl);
            location.href = "ybtour://openBrowser?url=".concat(encodedUrl);
        } else {
            window.open(mdspUrl, target);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupWrap, {
        ref: wrapRef,
        "data-show": String(show),
        animate: animate,
        show: show,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupDimm, {
                onClick: function() {
                    return setAnimate(!show);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: lv2DspNm
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupCloseButton, {
                                onClick: function() {
                                    return setAnimate(!show);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "창 닫기"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupArea, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: categoryList.length && categoryList.map(function(category) {
                                var dspSid = category.dspSid, dspNm = category.dspNm, mdspUrl = category.mdspUrl, mwebMenuTarget = category.mwebMenuTarget;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioWrap, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "radio",
                                                id: dspSid,
                                                name: "category",
                                                defaultChecked: dspSid === queryDspSid,
                                                onClick: function() {
                                                    return handleClick(mdspUrl, mwebMenuTarget);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: dspSid,
                                                children: dspNm
                                            })
                                        ]
                                    })
                                }, dspSid);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Mobile_Category = (Category);

// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/ui/mobile/text/index.ts + 2 modules
var mobile_text = __webpack_require__(6671);
;// CONCATENATED MODULE: ./framework/ui/mobile/header/NewHeader.tsx

function NewHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: ",
        ';\n	top: 0;\n	z-index: 15;\n	background-color: #fff;\n	box-sizing: border-box;\n\n	h1 {\n		margin: 0;\n	}\n\n	h1 a {\n		display: block;\n		height: 30px;\n	}\n\n	h2 {\n		color: #222;\n		font-family: "PT-bold";\n		font-size: 21px;\n		letter-spacing: normal;\n	}\n\n	img {\n		vertical-align: top;\n		width: 100%;\n		height: 100%;\n	}\n'
    ]);
    NewHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	height: 60px;\n	padding: 0 15px;\n	border-bottom: 1px solid #ddd;\n"
    ]);
    NewHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NewHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 20px;\n	height: 20px;\n	margin-right: 15px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -17px 0 / 150px 50px no-repeat;\n"
    ]);
    NewHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NewHeader_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-right: 21px;\n\n	&::after {\n		position: absolute;\n		top: 7px;\n		right: 2px;\n		display: inline-block;\n		width: 8px;\n		height: 8px;\n		border-top: 2px solid #222;\n		border-right: 2px solid #222;\n		transform: rotate(135deg);\n		content: "";\n	}\n'
    ]);
    NewHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NewHeader_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-block;\n	width: 22px;\n	height: 24px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -40px 0 / 150px 50px no-repeat;\n"
    ]);
    NewHeader_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NewHeader_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-block;\n	width: 23px;\n	height: 24px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -65px 0 / 150px 50px no-repeat;\n	cursor: pointer;\n\n	",
        "\n"
    ]);
    NewHeader_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NewHeader_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-block;\n	width: 24px;\n	height: 24px;\n	background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -90px 0 / 150px 50px no-repeat;\n	cursor: pointer;\n\n	&:active {\n		background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) -25px -25px / 150px 50px no-repeat;\n	}\n"
    ]);
    NewHeader_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-content: center;\n	gap: 10px;\n	margin-left: auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n\n	img {\n		width: 100%;\n		vertical-align: top;\n	}\n\n	a {\n		display: block;\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	right: 15px;\n	top: 50%;\n	width: 22px;\n	height: 22px;\n	padding: 0;\n	margin: 0;\n	border: 0;\n	background: none;\n	transform: translateY(-50%);\n\n	&::before,\n	&::after {\n		position: absolute;\n		right: 0;\n		height: 1px;\n		width: 20px;\n		background: #000;\n		border-radius: 1px;\n		content: "";\n	}\n\n	&::before {\n		transform: rotate(45deg);\n	}\n\n	&::after {\n		transform: rotate(-45deg);\n	}\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var HeaderWrap = styled_components_browser_esm["default"].header.withConfig({
    componentId: "sc-20d89e0a-0"
})(NewHeader_templateObject(), function(props) {
    return props.$isNotFixed ? "relative" : "sticky";
});
var Wrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-20d89e0a-1"
})(NewHeader_templateObject1());
var BtnBack = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-20d89e0a-2"
})(NewHeader_templateObject2());
var BtnCategory = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-20d89e0a-3"
})(NewHeader_templateObject3());
var BtnMain = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-20d89e0a-4"
})(NewHeader_templateObject4());
var BtnLike = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-20d89e0a-5"
})(NewHeader_templateObject5(), function(props) {
    return props.isActive && "\n        background: url(https://cimgcdn.ybtour.co.kr/common/header/ico_spr_m.png) 0px -25px / 150px 50px no-repeat;\n    ";
});
var BtnShare = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-20d89e0a-6"
})(NewHeader_templateObject6());
var BtnGroup = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-20d89e0a-7"
})(_templateObject7());
var TopBanner = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-20d89e0a-8"
})(_templateObject8());
var BtnBannerClose = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-20d89e0a-9"
})(_templateObject9());
var Header = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(HeaderWrap, {
                children: [
                    /*#__PURE__*/ _jsxs(TopBanner, {
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: "#",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "https://cimgcdn.ybtour.co.kr/promotion/etc/@sample/@sample_top_banner_m.jpg",
                                    alt: "배너 이미지"
                                })
                            }),
                            /*#__PURE__*/ _jsx(BtnBannerClose, {
                                type: "button",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "blind-ir",
                                    children: "배너 닫기"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Wrap, {
                        children: [
                            /*#__PURE__*/ _jsx(BtnBack, {
                                type: "button",
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: "뒤로가기"
                                })
                            }),
                            /*#__PURE__*/ _jsx(BtnCategory, {
                                type: "button",
                                children: /*#__PURE__*/ _jsx("h2", {
                                    children: "카테고리"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(HeaderWrap, {
                children: /*#__PURE__*/ _jsxs(Wrap, {
                    children: [
                        /*#__PURE__*/ _jsx(BtnBack, {
                            type: "button",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "뒤로가기"
                            })
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            children: "페이지명"
                        }),
                        /*#__PURE__*/ _jsx(BtnGroup, {
                            children: /*#__PURE__*/ _jsx(BtnMain, {
                                href: "https://m.ybtour.co.kr/index.yb",
                                children: /*#__PURE__*/ _jsx(Accessibility, {
                                    children: "메인 페이지로 이동"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(HeaderWrap, {
                children: /*#__PURE__*/ _jsxs(Wrap, {
                    children: [
                        /*#__PURE__*/ _jsx(BtnBack, {
                            type: "button",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "뒤로가기"
                            })
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            children: "페이지명"
                        }),
                        /*#__PURE__*/ _jsxs(BtnGroup, {
                            children: [
                                /*#__PURE__*/ _jsx(BtnMain, {
                                    href: "https://m.ybtour.co.kr/index.yb",
                                    children: /*#__PURE__*/ _jsx(Accessibility, {
                                        children: "메인 페이지로 이동"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(BtnLike, {
                                    type: "button",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        children: "찜한 상품"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(BtnShare, {
                                    type: "button",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        children: "공유하기"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(HeaderWrap, {
                children: /*#__PURE__*/ _jsxs(Wrap, {
                    children: [
                        /*#__PURE__*/ _jsx(BtnBack, {
                            type: "button",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: "뒤로가기"
                            })
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            children: "페이지명"
                        }),
                        /*#__PURE__*/ _jsxs(BtnGroup, {
                            children: [
                                /*#__PURE__*/ _jsx(BtnMain, {
                                    href: "https://m.ybtour.co.kr/index.yb",
                                    children: /*#__PURE__*/ _jsx(Accessibility, {
                                        children: "메인 페이지로 이동"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(BtnLike, {
                                    type: "button",
                                    isActive: true,
                                    children: /*#__PURE__*/ _jsx("span", {
                                        children: "찜한 상품"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(BtnShare, {
                                    type: "button",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        children: "공유하기"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

/* harmony default export */ var NewHeader = ((/* unused pure expression or super */ null && (Header)));

// EXTERNAL MODULE: ./hooks/services/queries/account/useCustomerMe.ts + 1 modules
var useCustomerMe = __webpack_require__(38186);
// EXTERNAL MODULE: ./hooks/services/queries/essential/customer/useWishlist.ts
var useWishlist = __webpack_require__(61817);
;// CONCATENATED MODULE: ./components/layout/header/Mobile/index.tsx

















var WishList = (0,withWishList/* default */.Z)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnLike, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        icon: "wishList"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "찜한 상품"
        })
    }));
});
var Tool = function(param) {
    var tools = param.tools, _pageProps = param.pageProps, _evCd = _pageProps.evCd, evCd = _evCd === void 0 ? "" : _evCd, _dspSid = _pageProps.dspSid, dspSid = _dspSid === void 0 ? "" : _dspSid, _menu = _pageProps.menu, menu = _menu === void 0 ? "" : _menu, wishAddConfirm = param.wishAddConfirm, wishRemoveConfirm = param.wishRemoveConfirm;
    var ref, ref1, ref2, ref3, ref4;
    /** 로그인 */ var signin = (0,useCustomerMe/* default */.ZP)();
    var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
    /** 찜한 상품 */ var useWish = (0,useWishlist/* default */.Z)(webCustNo, {
        enabled: !!webCustNo,
        throwOnError: false
    });
    var wishlist = ((ref1 = useWish.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.body) === null || ref2 === void 0 ? void 0 : ref2.wishProductsResultList) || [];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref5[0];
    var share = function() {
        open(function(overlay) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
                baseUrl: "".concat(location.origin).concat(location.pathname),
                parameter: location.search
            }));
        });
    };
    var isWishNo = ((ref4 = (ref3 = wishlist.filter(function(wish) {
        return wish.evCd === evCd;
    })) === null || ref3 === void 0 ? void 0 : ref3.at(0)) === null || ref4 === void 0 ? void 0 : ref4.productWishId) || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnGroup, {
        children: tools.map(function(tool, i) {
            if (tool === "home") return /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnMain, {
                href: config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL,
                onClick: function(e) {
                    return (0,commonUtil/* onClickSSO */.Zy)(e, config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_text/* Accessibility */.yq, {
                    children: "메인 페이지로 이동"
                })
            }, i);
            else if (tool === "wish") return /*#__PURE__*/ (0,jsx_runtime.jsx)(WishList, {
                isActive: !!isWishNo,
                wishNo: isWishNo,
                diviCd: "E",
                evCd: evCd,
                addConfirm: wishAddConfirm,
                removeConfirm: wishRemoveConfirm,
                link: "/product/detailPackage?menu=".concat(menu, "&dspSid=").concat(dspSid, "&evCd=").concat(evCd)
            }, i);
            else if (tool === "share") return /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnShare, {
                type: "button",
                onClick: share,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "공유하기"
                })
            }, i);
            else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            }
        })
    });
};
var CategoryList = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref4[0];
    var router = (0,next_router.useRouter)();
    /** 메뉴 관련 */ var globalMenu = ((ref = (0,useGlobalMenu/* default */.Z)()) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.body) || null;
    var menuLv3List = (globalMenu === null || globalMenu === void 0 ? void 0 : globalMenu.menuLv3List) || [];
    /** dspSid Lv3 */ var currentDspSid = ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.dspSid) || "";
    var dspNmLv3 = ((ref3 = menuLv3List.find(function(o) {
        return o.dspSid === currentDspSid && o.mobileYn === "Y";
    })) === null || ref3 === void 0 ? void 0 : ref3.dspNm) || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnCategory, {
        type: "button",
        onClick: function() {
            return open(function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Category, (0,_object_spread/* default */.Z)({}, props));
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            children: dspNmLv3
        })
    });
};
var Mobile_Header = function(props) {
    var _notFixed = props.notFixed, notFixed = _notFixed === void 0 ? false : _notFixed, category = props.category, title = props.title, _tools = props.tools, tools = _tools === void 0 ? [] : _tools, wishAddConfirm = props.wishAddConfirm, wishRemoveConfirm = props.wishRemoveConfirm;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrap, {
            $isNotFixed: notFixed,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnBack, {
                        type: "button",
                        onClick: function() {
                            return history.back();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "뒤로가기"
                        })
                    }),
                    category ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tool, {
                        tools: tools,
                        pageProps: props.pageProps || {},
                        wishAddConfirm: wishAddConfirm,
                        wishRemoveConfirm: wishRemoveConfirm
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var header_Mobile = (/*#__PURE__*/(0,react.memo)(Mobile_Header));


/***/ }),

/***/ 6243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CR": function() { return /* binding */ D_DELETE_EXCLUDE_KEYS; },
/* harmony export */   "D9": function() { return /* binding */ D_SHOW_KEYS; },
/* harmony export */   "Dw": function() { return /* binding */ L_SHOW_KEYS; },
/* harmony export */   "we": function() { return /* binding */ D_EXCLUDE_KEYS; }
/* harmony export */ });
/**
 * D_ : 출발일보기
 * L_ : 상품리스트
 */ /** ```
 *  상품리스트 필터 순서 보정
 * "outStartDateList" // 출발 일정 월, 날짜,
 * "wdayList" // 출발 일정 요일,
 * "outDeprtFgList" // 출발 시간,
 * "outCityDiviNm" // 출발지(공항),
 * "evDayCntList" // 여행기간,
 * "minPrice" // 최소금액,
 * "maxPrice" // 최대금액,
 * "airCd" // 이용교통,
 * "goodsFeaturesList" // 상품특징,
 * "goodsPromotion" // 프로모션,
 * "goodsTmember" // 여행구성원,
 * "goodsNm" // 상품 상세 검색,
 ``` */ var L_SHOW_KEYS = [
    "outStartDateList" /* 출발 일정 월, 날짜 */ ,
    "wdayList" /* 출발 일정 요일*/ ,
    "outDeprtFgList" /* 출발 시간 */ ,
    "outCityDiviNm" /* 출발지(공항) */ ,
    "evDayCntList" /* 여행기간 */ ,
    "minPrice" /* 최소금액 */ ,
    "maxPrice" /* 최대금액 */ ,
    "airCd" /* 이용교통 */ ,
    "goodsFeaturesList" /* 상품특징 */ ,
    "goodsPromotion" /* 프로모션 */ ,
    "goodsTmember" /* 여행구성원 */ ,
    "goodsNm" /* 상품 상세 검색 */ , 
];
/** ```
 * 출발일 보기에서 보여줄 필터
 * "outStartDt" // 출발 일자 ,
 * "wdayList" // 출발 일정 요일,
 * "outDeprtFgList" // 출발 시간 ,
 * "outCityDiviNm" // 출발지(공항) ,
 * "evDayCntList" // 여행기간 ,
 * "minPrice" // 최소금액 ,
 * "maxPrice" // 최대금액 ,
 ``` */ var D_SHOW_KEYS = [
    // "outStartDateList" /* 출발 일정 월, 날짜 */,
    "outStartMonth" /* 출발월 */ ,
    "outStartDt" /* 출발 일자 */ ,
    "wdayList" /* 출발 일정 요일*/ ,
    "outDeprtFgList" /* 출발 시간 */ ,
    "outCityDiviNm" /* 출발지(공항) */ ,
    "evDayCntList" /* 여행기간 */ ,
    "minPrice" /* 최소금액 */ ,
    "maxPrice" /* 최대금액 */ , 
];
/** ```
 * 출발일 보기에서 전체삭제 제외 필터
 * "isEvReserve", // 예약가능
 * "isEvConfirm", // 출발확정
 * "trCompanySnm", // 교통편
 * "accomSeq", // 옵션
 ``` */ var D_DELETE_EXCLUDE_KEYS = [
    "isEvReserve",
    "isEvConfirm",
    "trCompanySnm",
    "accomSeq"
];
/** ```
 * 출발일 보기에서 사용하지 않는 필터
 * "outStartMonth", // 출발 월
 * "goodsNm", // 상품명
 * "goodsFeaturesList", // 상품특징
 * "goodsPromotion", // 프로모션
 * "goodsTmember", // 여행구성원
 * "airCd", // 리스트에서 선택한 교통편
 * "dspSid",
``` */ var D_EXCLUDE_KEYS = [
    // "outStartMonth", // 출발 월
    "goodsNm",
    "goodsFeaturesList",
    "goodsPromotion",
    "goodsTmember",
    "airCd",
    "dspSid", 
];



/***/ }),

/***/ 62306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mobile_EventListPopup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useLocalDataStore.tsx
var useLocalDataStore = __webpack_require__(72031);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/modal/share/Mobile.tsx + 3 modules
var Mobile = __webpack_require__(82864);
// EXTERNAL MODULE: ./components/style/productlist/departurepopupM.tsx
var departurepopupM = __webpack_require__(86594);
// EXTERNAL MODULE: ./framework/ui/mobile/popup/index.ts + 3 modules
var popup = __webpack_require__(62835);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventByMonth.ts
var useEventByMonth = __webpack_require__(67964);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsDetail.ts
var useGoodsDetail = __webpack_require__(3081);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsOneAvailEvent.ts
var useGoodsOneAvailEvent = __webpack_require__(51820);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsOption.ts
var useGoodsOption = __webpack_require__(29306);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./components/product/pages/localList/common/filterHook.tsx
var filterHook = __webpack_require__(87061);
// EXTERNAL MODULE: ./components/product/common/popup/common/constant.ts
var constant = __webpack_require__(6243);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/flag/Mobile.tsx
var flag_Mobile = __webpack_require__(28403);
// EXTERNAL MODULE: ./framework/ui/mobile/button/IconButton.tsx
var IconButton = __webpack_require__(8956);
// EXTERNAL MODULE: ./framework/ui/mobile/layout/index.tsx + 2 modules
var layout = __webpack_require__(48418);
// EXTERNAL MODULE: ./framework/ui/mobile/text/index.ts + 2 modules
var mobile_text = __webpack_require__(6671);
// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalGoodsLive.ts
var useGlobalGoodsLive = __webpack_require__(28906);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerContents.ts
var useBannerContents = __webpack_require__(72204);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerGoodsDeal.ts
var useBannerGoodsDeal = __webpack_require__(82767);
// EXTERNAL MODULE: ./hooks/services/queries/portal/useGoodsBannerPick.ts
var useGoodsBannerPick = __webpack_require__(38307);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./hooks/common/useCountdown.tsx
var useCountdown = __webpack_require__(71392);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./components/common/ssoLink/index.tsx
var ssoLink = __webpack_require__(50142);
// EXTERNAL MODULE: ./public/M/images/content/event/yellowpick/banner_yellowpick_585.png
var banner_yellowpick_585 = __webpack_require__(28206);
var banner_yellowpick_585_default = /*#__PURE__*/__webpack_require__.n(banner_yellowpick_585);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/EventListBanner.tsx











var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var BannerContents = function(param) {
    var bannerContents = param.bannerContents;
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_calender", {
        selectDiv: "calenderMidBanner"
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* EventBanner */.cK, {
        children: bannerContents && bannerContents.map(function(banner, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ssoLink/* default */.Z, {
                href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL).concat(banner.mLink),
                target: (0,commonUtil/* getTarget */.U9)(banner.mTarget),
                onClick: function() {
                    return taggingClick(banner);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(banner.mImgPath),
                    alt: banner.mAlt
                })
            }, idx);
        })
    });
};
var BannerYellowLive = function(param) {
    var live = param.live;
    dayjs_min_default().extend((isBetween_default())); // isBetween 사용
    var dspYn = live.dspYn, liveDt = live.liveDt, liveTime = live.liveTime;
    // 방송 노출 조건 Y가 아닌 경우 - 노출 X
    if (dspYn !== "Y") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var liveStartDate = dayjs_min_default()(liveDt);
    var liveEndDate = liveStartDate.add(Number(liveTime), "minute");
    var today = dayjs_min_default()();
    var LiveText = function() {
        if (today.isBefore(liveStartDate)) {
            var countdown = (0,useCountdown/* default */.Z)(liveStartDate);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* LiveDate */.Uq, {
                        children: "COMING SOON"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* LiveState */.I7, {
                        children: countdown
                    })
                ]
            });
        } else if (today.isBetween(liveStartDate, liveEndDate)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* LiveDate */.Uq, {
                        children: "ON AIR"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* LiveState */.I7, {
                        children: "실시간 방송 중"
                    })
                ]
            });
        } else {
            var formattedDate = "".concat(liveStartDate.format("MM/DD"), "(").concat(daykor[liveStartDate.day()], ") ").concat(liveStartDate.format("HH:mm"));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* LiveDate */.Uq, {
                        children: formattedDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* LiveState */.I7, {
                        children: "방영 완료"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* BannerYellowLive */.$g, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
            href: "".concat(config_public/* default.ENV_PORTAL_M_URL */.Z.ENV_PORTAL_M_URL, "/promotion/yellowLive"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* LiveText */.sS, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* LiveTit */.TH, {
                            children: "최대 혜택으로 떠나는 생생한 여행"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveText, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* LiveLink */.Ge, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "바로가기"
                    })
                })
            ]
        })
    });
};
var BannerYellowPangDeal = function(param) {
    var deal = param.deal;
    var PangdealText = function() {
        var targetDate = dayjs_min_default()(deal.dealEdTm).add(1, "minute");
        var countdown = (0,useCountdown/* default */.Z)(targetDate);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* PriceBox */.bz, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* PangdealProduct */.pb, {
                            children: deal.dealType === "T" ? "타임특가" : "선착순특가"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* PangdealDate */.Q0, {
                            children: deal.dealType === "T" ? countdown !== null && countdown !== void 0 ? countdown : "종료" : "상품 ".concat(deal.dealRervCnt || 0, "개")
                        }),
                        "\xa0",
                        countdown !== null && " 남음"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "".concat(deal.dealRervCnt > 0 || countdown !== null ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(deal.price - deal.dealGoodsPrice), "원 즉시할인가격") : "")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
        target: "_self",
        href: "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/promotion/yellowPangDeal.yb"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* PangdealPrice */.G_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PangdealText, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* PangdealLink */.rV, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "전체보기"
                })
            })
        ]
    });
};
var BannerYellowPick = function(param) {
    var pick = param.pick;
    var link = pick.webBannerLink === "AUTOLINK" ? "".concat(config_public/* default.ENV_PACKAGE_M_URL */.Z.ENV_PACKAGE_M_URL, "/promotion/promotionDetail.yb?mstNo=").concat(pick.bnrMstNo) : pick.mlink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* EventBanner */.cK, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: link,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (banner_yellowpick_585_default()),
                alt: "옐로PICK 혜택 특가로 떠나는 이달의 여행지"
            })
        })
    });
};


;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/EventListInfo.tsx
















var EventListInfoComponent = function(param) {
    var goodsCd = param.goodsCd, productDetail = param.productDetail, handleShare = param.handleShare;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var _query = router.query, menu = _query.menu, dspSid = _query.dspSid;
    var bannerContentsFetch = (0,useBannerContents/* default */.ZP)("GOST");
    var bannerContents = ((ref = bannerContentsFetch.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var bannerDealFetch = (0,useBannerGoodsDeal/* default */.ZP)(goodsCd);
    var bannerDeal = (ref1 = bannerDealFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var bannerLiveFetch = (0,useGlobalGoodsLive/* default */.Z)(goodsCd);
    var bannerLive = (ref2 = bannerLiveFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    var bannerPickFetch = (0,useGoodsBannerPick/* default */.ZP)(goodsCd);
    var bannerPick = (ref3 = bannerPickFetch.data) === null || ref3 === void 0 ? void 0 : ref3.body;
    if (!menu && !dspSid) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* ContentTop */.an, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* SummaryInfo */.T7, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* ScoreText */.Tp, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* StarImg */.$H, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: productDetail.rvwAvgScore > 0 ? productDetail.rvwAvgScore : "-"
                                    }),
                                    "/ 5"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                type: "button",
                                icon: "share",
                                onClick: function() {
                                    return handleShare();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "공유하기"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        gap: "3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagGoodsCd */.G, {
                                goodsCd: productDetail.goodsCd
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagGoodsTp */.B2, {
                                goodsTp: productDetail.goodsTp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagGoodsBrandCd */.hA, {
                                goodsBrandCd: productDetail.goodsBrandCd
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagGoodsTmember */.$4, {
                                goodsTmember: productDetail.goodsTmember
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* TopTitle */.ne, {
                        children: productDetail.goodsNm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* TopPriceBox */.Yo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                align: "center",
                                gap: "8",
                                children: [
                                    "최저가",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(mobile_text/* RedText */.xK, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(productDetail.minPrice)
                                            }),
                                            "원"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* TopPriceDate */.Su, {
                                        children: [
                                            "(",
                                            dayjs_min_default()(productDetail.minPriceDate).format("YYYY.MM.DD"),
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                align: "center",
                                gap: "8",
                                children: [
                                    "최고가",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(mobile_text/* RedText */.xK, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(productDetail.maxPrice)
                                            }),
                                            "원"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* TopPriceDate */.Su, {
                                        children: [
                                            "(",
                                            dayjs_min_default()(productDetail.maxPriceDate).format("YYYY.MM.DD"),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (bannerContents.length > 0 || bannerDeal || bannerLive) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* EventBannerWrap */.st, {
                children: [
                    bannerContents.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContents, {
                        bannerContents: bannerContents
                    }),
                    bannerPick && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowPick, {
                        pick: bannerPick
                    }),
                    bannerDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowPangDeal, {
                        deal: bannerDeal
                    }),
                    bannerLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowLive, {
                        live: bannerLive
                    })
                ]
            })
        ]
    });
};
var EventListInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DeparetureDayPopup Info Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListInfoComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var EventListPopup_EventListInfo = (EventListInfo);

// EXTERNAL MODULE: ./framework/ui/mobile/filter/index.tsx
var filter = __webpack_require__(10696);
;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/EventListState.tsx




var EventListState = function(param) {
    var state = param.state, index = param.index, productDetail = param.productDetail;
    var ref = (0,useLocalDataStore/* default */.Z)(), getLocalData = ref.getLocalData, addLocalData = ref.addLocalData, setLocalData = ref.setLocalData;
    var ref1;
    var filters = (ref1 = getLocalData("departureFilters")) !== null && ref1 !== void 0 ? ref1 : [];
    var handleChange = function(e) {
        var key = state.key;
        var _target = e.target, checked = _target.checked, value = _target.value;
        var text = e.target.parentNode.lastChild.textContent;
        if (checked) {
            var hasFilter = filters.some(function(item) {
                return item.value === value && item.key === key;
            });
            if (hasFilter) return;
            addLocalData({
                key: "departureFilters",
                value: {
                    key: key,
                    value: value,
                    text: text
                }
            });
        } else {
            setLocalData({
                key: "departureFilters",
                value: filters.filter(function(item) {
                    return !(item.value === value && item.key === key);
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* FilterCheck */.yF, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                id: "state".concat(productDetail.goodsCd).concat(index),
                name: "state".concat(productDetail.goodsCd).concat(index),
                value: state.value,
                checked: filters.some(function(v) {
                    return v.key === state.key || false;
                }),
                onChange: handleChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "state".concat(productDetail.goodsCd).concat(index),
                children: state.text
            })
        ]
    });
};
/* harmony default export */ var EventListPopup_EventListState = (EventListState);

;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/EventlistFilters.tsx











var goodsState = [
    {
        key: "isEvReserve",
        text: "예약가능",
        value: "true"
    },
    {
        key: "isEvConfirm",
        text: "출발확정",
        value: "true"
    }, 
];
var EventListFiltersComponent = function(param) {
    var removeAllFilters = param.removeAllFilters, removeFilter = param.removeFilter, goodsCd = param.goodsCd, option = param.option, productDetail = param.productDetail, openTrafficPopup = param.openTrafficPopup, openOptionPopup = param.openOptionPopup;
    var getLocalData = (0,useLocalDataStore/* default */.Z)().getLocalData;
    var filters = getLocalData("departureFilters") || [];
    // 상품 리스트 필터
    var productListFilter = (0,react.useMemo)(function() {
        var arr = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (key === "minPrice") {
                    var minPrice = filters.find(function(v) {
                        return v.key === "minPrice";
                    });
                    if (minPrice) arr = (0,_to_consumable_array/* default */.Z)(arr).concat([
                        {
                            key: "price",
                            text: minPrice.text
                        }
                    ]);
                } else if (key === "maxPrice") {
                    var maxPrice = filters.find(function(v) {
                        return v.key === "maxPrice";
                    });
                    var priceObject = arr.find(function(v) {
                        return v.key === "price";
                    });
                    if (priceObject && maxPrice) priceObject.text += " ~ ".concat(maxPrice.text);
                } else {
                    arr = (0,_to_consumable_array/* default */.Z)(arr).concat((0,_to_consumable_array/* default */.Z)(filters.filter(function(v) {
                        return v.key === key;
                    })));
                }
            };
            for(var _iterator = constant/* D_SHOW_KEYS */.D9[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return arr;
    }, [
        filters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (productListFilter === null || productListFilter === void 0 ? void 0 : productListFilter.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(filter/* TagContainer */.x5, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ResetButton */.JK, {
                        type: "button",
                        onClick: removeAllFilters,
                        children: "전체삭제"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* FilterTagWrap */.Ck, {
                        children: productListFilter.map(function(ftr, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(filter/* FilterTag */.dB, {
                                children: [
                                    ftr.text,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        onClick: function() {
                                            return removeFilter(ftr.key, ftr.value);
                                        },
                                        children: "닫기"
                                    })
                                ]
                            }, "".concat(goodsCd).concat(index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Area */.uN, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* FilterCheckWrap */.FB, {
                    children: [
                        goodsState.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_EventListState, {
                                state: item,
                                index: index,
                                productDetail: productDetail
                            }, index);
                        }),
                        (option === null || option === void 0 ? void 0 : option.trafficList) && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* FilterCheck */.yF, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* FilterButton */.Lb, {
                                type: "button",
                                onClick: openTrafficPopup,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                    children: "교통편"
                                })
                            })
                        }),
                        productDetail.webDisplayCls === "B" && (option === null || option === void 0 ? void 0 : option.accommodationList) && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* FilterCheck */.yF, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* FilterButton */.Lb, {
                                type: "button",
                                onClick: openOptionPopup,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                    children: "옵션"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var EventListFilters = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListFiltersComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var EventlistFilters = (EventListFilters);

// EXTERNAL MODULE: ./hooks/common/useScrollRestoration.tsx
var useScrollRestoration = __webpack_require__(69530);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./framework/ui/mobile/icon/AirlineIcon.tsx
var AirlineIcon = __webpack_require__(27558);
;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/EventList.tsx














var EventList = function(param) {
    var eventList = param.eventList, sort = param.sort, currentDate = param.currentDate;
    var ref;
    var ref1 = (0,useLocalDataStore/* default */.Z)(), getLocalData = ref1.getLocalData, setLocalData = ref1.setLocalData;
    var ref2;
    var filters = (ref2 = getLocalData("departureFilters")) !== null && ref2 !== void 0 ? ref2 : [];
    var router = (0,next_router.useRouter)();
    var sortedEventList = (0,react.useMemo)(function() {
        var filterList = (0,_to_consumable_array/* default */.Z)(eventList);
        var prop = sort.prop, asc = sort.asc;
        if (currentDate) filterList = filterList.filter(function(v) {
            return v.outStartDt === currentDate;
        });
        /** 정렬 */ filterList = filterList.sort(function(a, b) {
            if (asc) {
                // eslint-disable-next-line no-nested-ternary
                return Number(a[prop]) > Number(b[prop]) ? 1 : Number(a[prop]) < Number(b[prop]) ? -1 : 0;
            } else {
                // eslint-disable-next-line no-nested-ternary
                return Number(b[prop]) > Number(a[prop]) ? 1 : Number(b[prop]) < Number(a[prop]) ? -1 : 0;
            }
        });
        return filterList;
    }, [
        eventList,
        sort,
        currentDate
    ]);
    // 예약 마감된 상품도 함께 보기
    var handleFilterReserve = function(e) {
        e.preventDefault();
        var copyArray = filters.filter(function(v) {
            return v.key !== "isEvReserve";
        });
        setLocalData({
            key: "departureFilters",
            value: copyArray
        });
    };
    // 예약가능 여부
    var isReserved = ((ref = filters.find(function(v) {
        return v.key === "isEvReserve";
    })) === null || ref === void 0 ? void 0 : ref.value) === "true";
    /** 상품 클릭 위치 저장 */ var ref3 = (0,useScrollRestoration/* scrollRestore */.L)(), getRestoreData = ref3.getRestoreData, setRestoreData = ref3.setRestoreData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ProductList */.cm, {
                children: sortedEventList.map(function(event, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* ProductItem */.Cd, {
                        onClick: function(e) {
                            e.preventDefault();
                            var _outStartDt;
                            /** 상품 클릭 데이터 저장 */ setRestoreData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRestoreData()), {
                                goodsCd: event.evCd.split("-")[0],
                                startMonth: (_outStartDt = event.outStartDt) !== null && _outStartDt !== void 0 ? _outStartDt : ""
                            }));
                            router.push(event.weblinkurl.replace(".yb", "") || "#");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* AirlineBox */.WQ, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                                        img: (0,eventUtil/* getTrafficIconUrl */.wz)(event),
                                        title: event.trTp ? "".concat(event.trCompanyNm) : "교통불포함",
                                        classes: event.seatClassCd && event.seatClassCd !== "EC" ? event.seatClassNm : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                        gap: "3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagEmpasisCd */.k0, {
                                                emphasisCd: event.emphasisCd
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(flag_Mobile/* FlagEvProgDivi */.X, {
                                                evProgDivi: event.evProgDivi,
                                                evProgDiviNm: event.evProgDiviNm
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* Date */.Ej, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "".concat((0,eventUtil/* departureStart */.jn)({
                                            evStartDt: event.outStartDt,
                                            outDeprtTm: event.outDeprtTm,
                                            isMobile: true
                                        }), " - ").concat((0,eventUtil/* returnArrival */.jp)({
                                            evArriveDt: event.inArriveDt,
                                            inArrvTm: event.inArrvTm,
                                            isMobile: true
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: event.dayStayInfo.replace(/^(\d)박(\d)일$/, "$1박 $2일")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ProductTitle */.tc, {
                                children: event.evNm
                            }),
                            event.accomNm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* PromotionOption */.Mo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "옵션"
                                    }),
                                    event.accomNm
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* ProductPriceBox */.wI, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* StatusText */.r2, {
                                        children: [
                                            [
                                                "F",
                                                "H"
                                            ].indexOf(event.goodsTp) === -1 && event.evProgDivi !== "05" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "(잔여 ",
                                                    event.avlilBlockQty,
                                                    "석)"
                                                ]
                                            }),
                                            event.evReserveStatus === "end" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ReservationStatus */.Jr, {
                                                state: "deadline",
                                                children: "예약마감"
                                            }),
                                            event.evReserveStatus === "wait" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ReservationStatus */.Jr, {
                                                state: "waiting",
                                                children: "예약대기"
                                            }),
                                            event.evReserveStatus === "can" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ReservationStatus */.Jr, {
                                                state: "possible",
                                                children: [
                                                    "F",
                                                    "H"
                                                ].indexOf(event.goodsTp) > -1 ? "예약접수가능" : "예약가능"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* ProductPrice */.jF, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(event.sumPrice)
                                            }),
                                            "원~"
                                        ]
                                    })
                                ]
                            }),
                            event.couponYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* CouponBox */.ql, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "쿠폰"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* CouponIcon */.zc, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            children: event.couponOptTy === "M" ? ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(event.couponDiscAmt) : "".concat(event.couponDiscRate, "%")
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            !eventList || eventList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* ProcutNone */.jY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: isReserved ? "해당 조건으로 예약가능한 상품이 없습니다." : "해당 조건의 상품이 없습니다."
                    }),
                    isReserved && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        onClick: handleFilterReserve,
                        children: "예약 마감된 상품도 함께 보기"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EventListPopup_EventList = (EventList);

;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/SelectSchedule.tsx








// 일정 선택(출발일순, 낮은가격순, 높은가격순 상품 정렬)
var RATINGS = [
    {
        id: "departure",
        text: "출발일순",
        prop: "outStartDt",
        asc: true
    },
    {
        id: "lowPrice",
        text: "낮은가격순",
        prop: "sumPrice",
        asc: true
    },
    {
        id: "highPrice",
        text: "높은가격순",
        prop: "sumPrice",
        asc: false
    }, 
];
var SelectScheduleComponent = function(param) {
    var eventsInCalendar = param.eventsInCalendar, currentDate = param.currentDate;
    var ref = (0,react.useState)(RATINGS[0]), sort = ref[0], setSort = ref[1];
    var handleSort = function(e) {
        var selected = e.target.selectedOptions[0];
        var _dataset = selected.dataset, text = _dataset.text, prop = _dataset.prop, asc = _dataset.asc;
        setSort({
            id: selected.value,
            text: text,
            prop: prop,
            asc: asc === "true"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* TitleWrap */.BV, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_text/* SubTitle */.DK, {
                        children: "일정 선택"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* FilterRightBox */.UQ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* SelectBox */.jL, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                onChange: handleSort,
                                value: sort.id,
                                children: RATINGS.map(function(rating, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: rating.id,
                                        "data-prop": rating.prop,
                                        "data-asc": rating.asc,
                                        "data-text": rating.text,
                                        children: rating.text
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ProductList */.cm, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_EventList, {
                    eventList: eventsInCalendar.eventList,
                    sort: sort,
                    currentDate: currentDate
                })
            })
        ]
    });
};
var SelectSchedule = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DepartureDayPopup SelectSchedule Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectScheduleComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var EventListPopup_SelectSchedule = (SelectSchedule);

// EXTERNAL MODULE: ./components/style/productlist/optionM.tsx
var optionM = __webpack_require__(22887);
;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/popup/OptionPopup.tsx









var OptionPopup = function(_param) {
    var goodsCd = _param.goodsCd, optionList = _param.optionList, overlayProps = (0,_object_without_properties/* default */.Z)(_param, [
        "goodsCd",
        "optionList"
    ]);
    var key = "accomSeq";
    var ref = (0,useLocalDataStore/* default */.Z)(), getLocalData = ref.getLocalData, addLocalData = ref.addLocalData, setLocalData = ref.setLocalData;
    var ref1;
    var filters = (ref1 = getLocalData("departureFilters")) !== null && ref1 !== void 0 ? ref1 : [];
    var handleChange = function(e) {
        var _target = e.target, checked = _target.checked, value = _target.value;
        var text = e.target.parentNode.lastChild.textContent;
        if (checked) {
            var hasFilter = filters.some(function(item) {
                return item.value === value && item.key === key;
            });
            if (hasFilter) return;
            addLocalData({
                key: "departureFilters",
                value: {
                    key: key,
                    value: value,
                    text: text
                }
            });
        } else {
            if (key === "accomSeq" && filters.filter(function(v) {
                return v.key === "accomSeq";
            }).length === 1) {
                return MessageUtil.alert("옵션은 최소 1개 이상 선택하셔야 합니다.");
            }
            setLocalData({
                key: "departureFilters",
                value: filters.filter(function(item) {
                    return !(item.value === value && item.key === key);
                })
            });
        }
    };
    var initialize = function() {
        var optionsExcluded = filters.filter(function(e) {
            return e.key !== key;
        });
        var allOptions = optionList.map(function(option) {
            return {
                key: key,
                value: option.accomSeq,
                text: option.accomNm
            };
        });
        setLocalData({
            key: "departureFilters",
            value: (0,_to_consumable_array/* default */.Z)(optionsExcluded).concat((0,_to_consumable_array/* default */.Z)(allOptions))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        title: "옵션 선택",
        animate: "slideIn",
        size: "toast",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(optionM/* IconButton */.hU, {
            onClick: initialize
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(optionM/* CheckList */.Su, {
            children: optionList.map(function(option, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(optionM/* CheckListItem */.O2, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "option".concat(goodsCd).concat(index),
                            type: "checkbox",
                            value: option.accomSeq,
                            checked: filters.some(function(v) {
                                return v.value.toString() === option.accomSeq.toString();
                            }) || false,
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "option".concat(goodsCd).concat(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: option.accomNm
                            })
                        })
                    ]
                }, index);
            })
        })
    }));
};
/* harmony default export */ var popup_OptionPopup = (OptionPopup);

// EXTERNAL MODULE: ./components/common/modal/alert/Mobile.tsx
var alert_Mobile = __webpack_require__(88515);
// EXTERNAL MODULE: ./components/style/productlist/trafficM.tsx
var trafficM = __webpack_require__(5142);
;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/popup/TrafficPopup.tsx












var TrafficPopup = function(_param) {
    var trafficList = _param.trafficList, goodsCd = _param.goodsCd, overlayProps = (0,_object_without_properties/* default */.Z)(_param, [
        "trafficList",
        "goodsCd"
    ]);
    var key = "trCompanySnm";
    var ref = (0,useLocalDataStore/* default */.Z)(), getLocalData = ref.getLocalData, addLocalData = ref.addLocalData, setLocalData = ref.setLocalData;
    var ref1;
    var filters = (ref1 = getLocalData("departureFilters")) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), showAlert = ref2[0];
    var handleChange = function(e) {
        var _target = e.target, checked = _target.checked, value = _target.value;
        var text = e.target.parentNode.lastChild.textContent;
        if (checked) {
            var hasFilter = filters.some(function(item) {
                return item.value === value && item.key === key;
            });
            if (hasFilter) return;
            addLocalData({
                key: "departureFilters",
                value: {
                    key: key,
                    value: value,
                    text: text
                }
            });
        } else {
            if (filters.filter(function(v) {
                return v.key === "trCompanySnm";
            }).length === 1) {
                return showAlert(function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Mobile/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        text: "교통편은 최소 1개 이상 선택하셔야 합니다."
                    }));
                });
            }
            setLocalData({
                key: "departureFilters",
                value: filters.filter(function(item) {
                    return !(item.value === value && item.key === key);
                })
            });
        }
    };
    var initialize = function() {
        var trafficsExcluded = filters.filter(function(e) {
            return e.key !== key;
        });
        var allTraffics = trafficList.map(function(tr) {
            return {
                key: key,
                value: tr.trCompanySnm,
                text: tr.trCompanyNm
            };
        });
        setLocalData({
            key: "departureFilters",
            value: (0,_to_consumable_array/* default */.Z)(trafficsExcluded).concat((0,_to_consumable_array/* default */.Z)(allTraffics))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        title: "교통편 선택",
        animate: "slideIn",
        size: "toast",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(trafficM/* IconButton */.hU, {
            onClick: initialize
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(trafficM/* CheckList */.Su, {
            children: trafficList.map(function(traffic, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(trafficM/* CheckListItem */.O2, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            id: "airline".concat(goodsCd).concat(index),
                            value: traffic.trCompanySnm,
                            checked: filters.some(function(v) {
                                return v.value === traffic.trCompanySnm;
                            }) || false,
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "airline".concat(goodsCd).concat(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: traffic.trCompanyNm
                            })
                        })
                    ]
                }, index);
            })
        })
    }));
};
/* harmony default export */ var popup_TrafficPopup = (TrafficPopup);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@yb/styled-px2rem/esm/index.esm.js
var index_esm = __webpack_require__(53842);
// EXTERNAL MODULE: ./framework/ui/mobile/select/index.ts + 1 modules
var mobile_select = __webpack_require__(78093);
// EXTERNAL MODULE: ./components/hoc/withCalendar.tsx
var withCalendar = __webpack_require__(25893);
// EXTERNAL MODULE: ./hooks/services/queries/essential/contents/useContentsHoliday.ts
var useContentsHoliday = __webpack_require__(6843);
;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/EventListCalendar.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	padding: 70px 0 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	background-color: #fff;\n\n	table {\n		tbody {\n			tr {\n				border-top: 1px solid var(--line-color);\n			}\n		}\n		th {\n			background-color: #fff;\n			text-align: center;\n			border-top: 0;\n		}\n		td {\n			position: relative;\n			height: 45px;\n			padding: 0;\n			&:not(:last-child) {\n				border-right: 1px solid #eee;\n			}\n\n			&:first-child {\n				color: var(--red-color);\n			}\n			&:last-child {\n				color: var(--blue-color);\n			}\n		}\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 14px;\n	display: flex;\n	width: 100%;\n	height: 50px;\n	background-color: #fff;\n	justify-content: center;\n	align-items: center;\n	z-index: 5;\n\n	em {\n		font-size: 22px;\n		font-weight: bold;\n		color: var(--emp-color);\n		line-height: 1;\n	}\n	label {\n		font-size: var(--medium-size);\n		font-weight: normal;\n	}\n	ul {\n		top: 50px;\n		left: 50%;\n		width: 100%;\n		max-height: 155px;\n		transform: translateX(-50%);\n		> li {\n			justify-content: center;\n			padding: 0;\n		}\n	}\n	> div {\n		width: auto;\n	}\n\n	",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 18px;\n	width: 12px;\n	height: 12px;\n	border-left: 1px solid var(--emp-color);\n	border-bottom: 1px solid var(--emp-color);\n	background-color: transparent;\n\n	&:disabled {\n		border-color: var(--bl-color);\n	}\n\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	border: 1px solid transparent;\n	border-bottom: 1px solid var(--line-color);\n	table-layout: fixed;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 10px;\n	box-sizing: border-box;\n	border-top: 1px solid var(--line-color);\n	font-size: var(--small-size);\n	color: var(--emp-color);\n	text-align: center;\n	&:first-child {\n		color: #ff5c46;\n	}\n	&:last-child {\n		color: #4567ad;\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	box-sizing: border-box;\n	height: 22px;\n	color: ",
        ";\n	vertical-align: top;\n	text-align: left;\n	cursor: ",
        ";\n\n	> span {\n		outline: 1px solid ",
        ";\n		box-sizing: border-box;\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			span {\n				border-radius: 50%;\n				background-color: var(--emp-color);\n				color: #fff;\n			}\n		"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 100%;\n	height: 100%;\n	padding-top: 2px;\n	align-items: start;\n	justify-content: center;\n	z-index: 1;\n\n	color: ",
        ";\n\n	span {\n		display: flex;\n		height: 18px;\n		padding: 0 4px 0 2px;\n		font-size: var(--small-size);\n		align-items: center;\n		justify-content: center;\n		line-height: 1;\n	}\n\n	",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			color: #ff3e24;\n		"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	display: flex;\n	bottom: 0;\n	width: 100%;\n	height: 22px;\n	font-size: 12px;\n	color: var(--default-color);\n	align-items: center;\n	justify-content: center;\n\n	",
        "\n	",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 50%;\n	right: 15px;\n	border-bottom: 1px solid var(--emp-color);\n	font-size: var(--defaul-size);\n	color: var(--emp-color);\n	line-height: 1;\n	transform: translateY(-50%);\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 109px;\n	padding-bottom: 30px;\n	border-bottom: 1px solid var(--line-color);\n	background-color: #fff;\n	z-index: 5;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	top: 0;\n	height: 100vh;\n	width: 100%;\n	background-color: #000;\n	opacity: 0.5;\n	z-index: 1;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}








var CalendarWrap = index_esm/* default.div */.ZP.div(_templateObject());
var CalendarBox = index_esm/* default.div */.ZP.div(_templateObject1());
var CalendarMonth = index_esm/* default.div */.ZP.div(_templateObject2(), function(props) {
    return props.isScroll && "\n		position: fixed;\n		top: 60px;\n		border-bottom: 1px solid var(--line-color);\n		transition: 0.3s ease-out;\n	";
});
var MonthButton = index_esm/* default.button */.ZP.button(_templateObject3(), function(props) {
    return props.types === "prev" ? "\n                left: 24%;\n                transform: rotate(45deg);\n            " : "\n                right: 29%;\n                transform: rotate(-135deg);\n            ";
});
var TableCalendarWrap = index_esm/* default.div */.ZP.div(_templateObject4());
var TableCalendar = index_esm/* default.table */.ZP.table(_templateObject5());
var Week = index_esm/* default.th */.ZP.th(_templateObject6());
var ProductDays = index_esm/* default.td */.ZP.td(_templateObject7(), function(props) {
    return props.isActive ? "var(--emp-color)" : "#aaa";
}, function(props) {
    return props.isActive ? "pointer" : "initial";
}, function(props) {
    return props.CheckedDay ? "var(--emp-color)" : "transparent";
});
var Day = index_esm/* default.span */.ZP.span(_templateObject9(), function(props) {
    return props.holiday ? "var(--red-color)" : "";
}, function(props) {
    return props.today && (0,index_esm/* css */.iv)(_templateObject8());
});
var ResStatus = index_esm/* default.div */.ZP.div(_templateObject11(), function(props) {
    if (props.state === "possible") {
        return "\n			background-color: var(--yellow-color);\n		  ";
    }
    if (props.state === "waiting") {
        return "\n			background-color: #bfd1f5;\n		  ";
    }
    if (props.state === "deadline") {
        return "\n			background-color: var(--line-color);\n		  ";
    }
}, function(props) {
    return props.lowestPrice && (0,index_esm/* css */.iv)(_templateObject10());
});
var CalendarButton = index_esm/* default.button */.ZP.button(_templateObject12());
var FixedCalendar = index_esm/* default.div */.ZP.div(_templateObject13());
var Dim = index_esm/* default.div */.ZP.div(_templateObject14());
var formatPrice = function(prop) {
    if (prop < 10000) {
        return "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(prop), "원~");
    }
    var million = Math.floor(prop / 10000);
    return "".concat(million, "만~");
};
var EventListCalendar = (0,withCalendar/* default */.Z)(function(props, ref) {
    var date = props.date, isNext = props.isNext, isPrevious = props.isPrevious, rangeMonth = props.rangeMonth, month = props.month, data = props.data, dateChange = props.dateChange, monthChange = props.monthChange, nextMonth = props.nextMonth, prevMonth = props.prevMonth;
    // 스크롤시 달력이 안보이면 달력 헤더 고정
    var monthRef = (0,react.useRef)(null);
    var calendarRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isShow = ref1[0], setIsShow = ref1[1];
    (0,react.useEffect)(function() {
        var options = {
            root: null,
            rooMargin: "0px",
            threshold: 0
        };
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.target === calendarRef.current) {
                    if (entry.isIntersecting) {
                        // 달력이 화면에 보일 때
                        setIsShow(false);
                    } else {
                        // 달력이 화면에 안 보일 때
                        setIsShow(true);
                    }
                }
            });
        }, options);
        if (calendarRef.current) {
            observer.observe(calendarRef.current);
        }
        return function() {
            observer.disconnect();
        };
    }, []);
    var ref2 = (0,react.useState)(false), isActive = ref2[0], setIsActive = ref2[1];
    var handleClick = function() {
        setIsActive(!isActive);
        if (isActive) {
            document.body.style.cssText = "\n				overflow: hidden;\n				";
        } else {
            document.body.style.cssText = "\n			overflow: hidden;\n			height: 100vh;\n			";
        }
    };
    var eventList = data === null || data === void 0 ? void 0 : data.eventList;
    var minPrice = data === null || data === void 0 ? void 0 : data.minPrice;
    var holidayFetch = (0,useContentsHoliday/* default */.ZP)(dayjs_min_default()(month).format("YYYY"), {
        staleTime: 1000 * 60 * 5
    });
    var today = dayjs_min_default()();
    var groupByEvStartDt = (0,react.useMemo)(function() {
        var result = {};
        if (!eventList) return result;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = eventList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var outStartDt = item.outStartDt;
                if (!result[outStartDt]) {
                    result[outStartDt] = [];
                }
                result[outStartDt].push(item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }, [
        eventList,
        month
    ]);
    // 날짜 매핑
    var makeEventDayList = (0,react.useCallback)(function(referenceDate) {
        var dayCount = referenceDate.date(1).daysInMonth();
        /** 1~7 월~일 */ var startWeekDay = referenceDate.day();
        var endWeekDay = referenceDate.date(dayCount).day();
        var firstWeekEmptyArray = Array(startWeekDay).fill(null);
        var lastWeekEmptyArray = Array(6 - endWeekDay).fill(null);
        var dayArray = Array(dayCount).fill(0).map(function(o, index) {
            var _Math;
            var ref, ref1, ref2, ref3;
            var result = {};
            var day = referenceDate.add(index, "day");
            var dayFormat = day.format("YYYYMMDD");
            /* 공휴일 */ var holiday = !!((ref = holidayFetch.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.find(function(v) {
                return v.calDt === dayFormat;
            }));
            /* 최저가 */ var priceArray = ((ref2 = groupByEvStartDt[dayFormat]) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                return item.sumPrice;
            })) || [];
            var price = priceArray.length > 0 ? (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(priceArray)) : 0;
            /* can: 예약가능, wait: 예약대기, end: 예약마감 */ var calStatusArray = ((ref3 = groupByEvStartDt[dayFormat]) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
                return item.evReserveStatus;
            })) || [];
            var resStatus = "";
            if (calStatusArray.includes("can")) {
                resStatus = "possible";
            } else if (calStatusArray.includes("wait")) {
                resStatus = "waiting";
            } else if (calStatusArray.includes("end")) {
                resStatus = "deadline";
            }
            result = {
                day: day,
                resStatus: resStatus,
                price: price,
                holiday: holiday
            };
            return result;
        });
        return (0,_to_consumable_array/* default */.Z)(firstWeekEmptyArray).concat((0,_to_consumable_array/* default */.Z)(dayArray), (0,_to_consumable_array/* default */.Z)(lastWeekEmptyArray));
    }, [
        groupByEvStartDt
    ]);
    // eveny day를 주 단위로 삽입
    var eventDayList = (0,react.useMemo)(function() {
        var days = makeEventDayList(month.date(1));
        return Array.from({
            length: days.length / 7
        }).map(function() {
            return days.splice(0, 7);
        });
    }, [
        makeEventDayList
    ]);
    /** default 값 초기화 */ (0,react.useEffect)(function() {
        if (month) dateChange(null);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarWrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarBox, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarMonth, {
                    ref: monthRef,
                    isScroll: isShow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_select/* Select */.P, {
                            types: "calendar",
                            width: "auto",
                            value: month.format("YYYYMM"),
                            onChange: function(e) {
                                monthChange(e.target.value.toString());
                                dateChange(null); // 선택일 초기화
                            },
                            children: rangeMonth === null || rangeMonth === void 0 ? void 0 : rangeMonth.map(function(day, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: day.format("YYYYMM"),
                                    children: day.format("YYYY.MM")
                                }, index);
                            })
                        }),
                        isPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                            types: "prev",
                            onClick: function() {
                                prevMonth();
                                dateChange(null);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "이전달"
                            })
                        }),
                        isNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                            types: "next",
                            onClick: function() {
                                nextMonth();
                                dateChange(null);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "다음달"
                            })
                        }),
                        isShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarButton, {
                            onClick: handleClick,
                            children: isActive ? "닫기" : "출발일 선택"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCalendarWrap, {
                    ref: calendarRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCalendar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                            children: "일"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                            children: "월"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                            children: "화"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                            children: "수"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                            children: "목"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                            children: "금"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                            children: "토"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: eventDayList === null || eventDayList === void 0 ? void 0 : eventDayList.map(function(week, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                                        children: week.map(function(item, weekIdx) {
                                            var day = item === null || item === void 0 ? void 0 : item.day;
                                            var price = (item === null || item === void 0 ? void 0 : item.price) || 0;
                                            var isDayActive = !(day < today.add(-1, "day")) && price > 0 || !!(item === null || item === void 0 ? void 0 : item.resStatus);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDays, {
                                                isActive: isDayActive,
                                                onClick: function() {
                                                    if (isDayActive) {
                                                        var isSameDay = date === null || date === void 0 ? void 0 : date.isSame(day);
                                                        dateChange(!isSameDay ? day : null);
                                                    }
                                                },
                                                CheckedDay: date && date.isSame(day),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Day, {
                                                        today: day && today.isSame(day, "day"),
                                                        holiday: item === null || item === void 0 ? void 0 : item.holiday,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: day && day.format("DD")
                                                        })
                                                    }),
                                                    price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResStatus, {
                                                        state: (item === null || item === void 0 ? void 0 : item.resStatus) || "",
                                                        lowestPrice: price === Number(minPrice),
                                                        children: formatPrice(price)
                                                    })
                                                ]
                                            }, weekIdx);
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                }),
                isActive && isShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedCalendar, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCalendar, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                                    children: "일"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                                    children: "월"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                                    children: "화"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                                    children: "수"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                                    children: "목"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                                    children: "금"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Week, {
                                                    children: "토"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: eventDayList === null || eventDayList === void 0 ? void 0 : eventDayList.map(function(week, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                                                children: week.map(function(item, weekIdx) {
                                                    var day = item === null || item === void 0 ? void 0 : item.day;
                                                    var price = (item === null || item === void 0 ? void 0 : item.price) || 0;
                                                    var isDayActive = !(day < today.add(-1, "day")) && price > 0 || !!(item === null || item === void 0 ? void 0 : item.resStatus);
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDays, {
                                                        isActive: isDayActive,
                                                        onClick: function() {
                                                            if (isDayActive) {
                                                                var isSameDay = date === null || date === void 0 ? void 0 : date.isSame(day);
                                                                dateChange(!isSameDay ? day : null);
                                                                // 달력 닫기
                                                                handleClick();
                                                            }
                                                        },
                                                        CheckedDay: date && date.isSame(day),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Day, {
                                                                today: day && today.isSame(day, "day"),
                                                                holiday: item === null || item === void 0 ? void 0 : item.holiday,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: day && day.format("DD")
                                                                })
                                                            }),
                                                            price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResStatus, {
                                                                state: (item === null || item === void 0 ? void 0 : item.resStatus) || "",
                                                                lowestPrice: price === Number(minPrice),
                                                                children: formatPrice(price)
                                                            })
                                                        ]
                                                    }, weekIdx);
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dim, {
                            onClick: function() {
                                return setIsActive(false);
                            }
                        })
                    ]
                })
            ]
        })
    });
});
/* harmony default export */ var EventListPopup_EventListCalendar = (EventListCalendar);

;// CONCATENATED MODULE: ./components/product/common/popup/mobile/EventListPopup/index.tsx

































var EventListPopup = function(_param) {
    var goodsCd = _param.goodsCd, _startMonth = _param.startMonth, startMonth = _startMonth === void 0 ? "" : _startMonth, overlayProps = (0,_object_without_properties/* default */.Z)(_param, [
        "goodsCd",
        "startMonth"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,useGoodsOneAvailEvent/* default */.ZP)(goodsCd), availEventData = ref6.data;
    var availableEvent = availEventData === null || availEventData === void 0 ? void 0 : availEventData.body;
    // 상품상세 출발일 변경 클릭 시 초기 Month 설정
    if (availableEvent && startMonth) {
        availableEvent.evStartDt = dayjs_min_default()(startMonth).format("YYYYMMDD");
    }
    var router = (0,next_router.useRouter)();
    var dspSid = (ref = router.query) === null || ref === void 0 ? void 0 : ref.dspSid;
    var getFilter = (0,filterHook/* default */.Z)().getFilter;
    var optionFetch = (0,useGoodsOption/* default */.ZP)(goodsCd, {
        staleTime: 1000 * 60
    });
    var option = (ref1 = optionFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var productDetailFetch = (0,useGoodsDetail/* default */.ZP)(goodsCd, {
        staleTime: 1000 * 60
    });
    var productDetail = (ref2 = productDetailFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    // 전체 필터 관리
    var ref7 = (0,useLocalDataStore/* default */.Z)(), getLocalData = ref7.getLocalData, setLocalData = ref7.setLocalData, removeLocalData = ref7.removeLocalData;
    var filters = getLocalData("departureFilters") || [];
    // 전체 필터 초기값 설정
    (0,react.useEffect)(function() {
        var ref;
        if (!option) return;
        // localList filter
        var currentFilter = ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== "sort";
        })) || [];
        // 예약 가능 옵션 활성화 (localList filter 중복 제거)
        var result = (0,_to_consumable_array/* default */.Z)(currentFilter.filter(function(v) {
            return v.key !== "airCd";
        }));
        // 출발일정 설정
        var outStartDateList = currentFilter.find(function(v) {
            return v.key === "outStartDateList";
        });
        if (outStartDateList) {
            if (outStartDateList.value.length === 6) {
                result.push({
                    key: "outStartMonth",
                    text: outStartDateList.text,
                    value: outStartDateList.value
                });
            } else if (outStartDateList.value.length === 8) {
                result.push({
                    key: "outStartDt",
                    text: outStartDateList.text,
                    value: outStartDateList.value
                });
            }
            result = result.filter(function(v) {
                return v.key !== "outStartDateList";
            });
        }
        // 상품 옵션 설정
        var accommodationList = option.accommodationList, trafficList = option.trafficList;
        // 숙소 옵션 추가
        if ((accommodationList === null || accommodationList === void 0 ? void 0 : accommodationList.length) > 0 && (productDetail === null || productDetail === void 0 ? void 0 : productDetail.webDisplayCls) === "B") {
            var _result;
            var accommodation = accommodationList.map(function(item) {
                return {
                    key: "accomSeq",
                    value: item.accomSeq.toString(),
                    text: item.accomNm
                };
            });
            (_result = result).push.apply(_result, (0,_to_consumable_array/* default */.Z)(accommodation));
        }
        // 교통편 옵션 추가
        if (currentFilter.find(function(v) {
            return v.key === "airCd";
        })) {
            var _result1;
            var ref1;
            // 필터에 선택된 항공사
            var airCdArray = (ref1 = currentFilter.filter(function(v) {
                return v.key === "airCd";
            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(i) {
                return i.value;
            });
            var traffic = trafficList.filter(function(item) {
                return airCdArray.includes(item.trCompanySnm);
            }).map(function(item) {
                return {
                    key: "trCompanySnm",
                    value: item.trCompanySnm,
                    text: item.trCompanyNm
                };
            });
            (_result1 = result).push.apply(_result1, (0,_to_consumable_array/* default */.Z)(traffic));
        } else {
            var _result2;
            // 필터에 선택된 항공사가 없을 경우, 전부 추가
            var traffic1 = trafficList.map(function(item) {
                return {
                    key: "trCompanySnm",
                    value: item.trCompanySnm,
                    text: item.trCompanyNm
                };
            });
            (_result2 = result).push.apply(_result2, (0,_to_consumable_array/* default */.Z)(traffic1));
        }
        setLocalData({
            key: "departureFilters",
            value: result
        });
        return function() {
            return removeLocalData("departureFilters");
        };
    }, [
        option
    ]);
    // 추가 필터(교통편, 옵션)
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref8[0];
    var removeAllFilters = function() {
        var setArray = filters.filter(function(v) {
            return constant/* D_DELETE_EXCLUDE_KEYS.includes */.CR.includes(v.key);
        });
        setLocalData({
            key: "departureFilters",
            value: setArray
        });
    };
    var removeFilter = function(key, value) {
        var filtered = filters.filter(function(e) {
            if (key === "price") {
                return !(e.key === "minPrice" || e.key === "maxPrice");
            } else {
                return !(e.key === key && e.value === value);
            }
        });
        setLocalData({
            key: "departureFilters",
            value: filtered
        });
    };
    // 교통 팝업 열기
    var openTrafficPopup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                _tmp = {};
                PopupUtil.promise(popup_TrafficPopup, (_tmp.goodsCd = goodsCd, _tmp.trafficList = option.trafficList, _tmp)).then(function() {
                    return (0,commonUtil/* appBottomScheme */.V3)(false);
                });
                return [
                    2
                ];
            });
        });
        return function openTrafficPopup() {
            return _ref.apply(this, arguments);
        };
    }();
    // 옵션 팝업 열기
    var openOptionPopup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                _tmp = {};
                PopupUtil.promise(popup_OptionPopup, (_tmp.goodsCd = goodsCd, _tmp.optionList = option.accommodationList, _tmp)).then(function() {
                    return (0,commonUtil/* appBottomScheme */.V3)(false);
                });
                return [
                    2
                ];
            });
        });
        return function openOptionPopup() {
            return _ref.apply(this, arguments);
        };
    }();
    // 출발일 선택(달력)
    var calendarRef = (0,react.useRef)(null);
    /** 행사리스트 필터링에 사용 (YYYYMMDD) */ var ref9 = (0,react.useState)(null), currentDate = ref9[0], setCurrentDate = ref9[1];
    /** 달력 세팅에 사용 (YYYYMM) */ var ref10 = (0,react.useState)(null), currentMonth = ref10[0], setCurrentMonth = ref10[1];
    /** 최소 날짜, 최대 날짜, 이벤트 날짜 세팅 */ var ref11 = (0,react.useMemo)(function() {
        if (!availableEvent) return [
            null,
            null
        ];
        var _eventMonthList = availableEvent.eventMonthList, minOutStartDt = _eventMonthList.minOutStartDt, maxOutStartDt = _eventMonthList.maxOutStartDt;
        setCurrentMonth(dayjs_min_default()(availableEvent.evStartDt).format("YYYYMM"));
        return [
            minOutStartDt,
            maxOutStartDt
        ];
    }, [
        availableEvent
    ]), minDate = ref11[0], maxDate = ref11[1];
    /** 필터링 된 날짜 세팅 */ (0,react.useEffect)(function() {
        if (!filters.length) return;
        var dateFilter = filters.find(function(v) {
            return v.key === "outStartDt";
        });
        var monthFilter = filters.find(function(v) {
            return v.key === "outStartMonth";
        });
        var newDate = dateFilter ? dateFilter.value : null;
        var newMonth = monthFilter ? monthFilter.value : null;
        newMonth && setCurrentMonth(newMonth);
        newDate && setCurrentMonth(dayjs_min_default()(newDate).format("YYYYMM"));
        newDate && setCurrentDate(newDate);
    }, [
        filters,
        minDate
    ]);
    /** 달력 동기화 */ (0,react.useEffect)(function() {
        var ref;
        (ref = calendarRef.current) === null || ref === void 0 ? void 0 : ref.monthChange(currentMonth);
    }, [
        currentMonth
    ]);
    var onMonthChange = function(date) {
        var newMonth = (date === null || date === void 0 ? void 0 : date.format("YYYYMM")) || null;
        setCurrentMonth(newMonth);
    };
    var onDateChange = function(date) {
        var newDate = (date === null || date === void 0 ? void 0 : date.format("YYYYMMDD")) || null;
        setCurrentDate(newDate);
    };
    var eventByGoodsMonthFetch = (0,useEventByMonth/* default */.Z)(dspSid, goodsCd, currentMonth, {
        enabled: !!currentMonth && !optionFetch.isLoading,
        staleTime: 1000 * 60,
        select: function select(data) {
            var eventData = data.body || [];
            // 필드 연산
            eventData.map(function(event) {
                var evProgDivi = event.evProgDivi, avlilBlockQty = event.avlilBlockQty, adtPrice = event.adtPrice, airTaxAdtPrice = event.airTaxAdtPrice, bafAdtPrice = event.bafAdtPrice;
                event.sumPrice = adtPrice + airTaxAdtPrice + bafAdtPrice;
                event.isEvReserve = "false"; // 예약가능 여부
                event.isEvConfirm = "false"; // 출발확정 여부
                if (evProgDivi !== "05" && (evProgDivi !== "00" && avlilBlockQty > 0 || evProgDivi === "00" || avlilBlockQty <= 0)) {
                    event.isEvReserve = "true";
                }
                if (evProgDivi === "07" || evProgDivi === "11") {
                    event.isEvConfirm = "true";
                }
                if (evProgDivi === "05") {
                    event.evReserveStatus = "end";
                } else if (evProgDivi === "00" || avlilBlockQty <= 0) {
                    event.evReserveStatus = "wait";
                } else {
                    event.evReserveStatus = "can";
                }
                return event.sumPrice;
            });
            return {
                minPrice: productDetail.minPrice,
                list: eventData
            };
        }
    });
    var organizedEventList = eventByGoodsMonthFetch.data;
    // 달력에 표기 되는 여행 리스트
    var eventsInCalendar = (0,react.useMemo)(function() {
        if (!organizedEventList) return;
        var minPrice = organizedEventList.minPrice, list = organizedEventList.list;
        var copyArray = list;
        filters === null || filters === void 0 ? void 0 : filters.forEach(function(item) {
            var filterKey = item.key;
            if (constant/* D_EXCLUDE_KEYS.indexOf */.we.indexOf(filterKey) > -1) return;
            copyArray = copyArray.reduce(function(acc, event) {
                var filterKeyList = filters.filter(function(v) {
                    return v.key === filterKey;
                });
                filterKeyList.some(function(filter) {
                    var key = filter.key, value = filter.value;
                    if (key === "minPrice") return Number(event.sumPrice) >= Number(value);
                    if (key === "maxPrice") return Number(event.sumPrice) <= Number(value);
                    return event[key] && event[key].indexOf(value) > -1;
                // eslint-disable-next-line no-param-reassign
                }) && (acc = acc.concat(event));
                return acc;
            }, []);
        });
        return {
            minPrice: minPrice,
            eventList: copyArray
        };
    }, [
        filters,
        organizedEventList,
        currentMonth
    ]);
    // 공유하기
    var menu = (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.menu;
    var pathDspSid = "".concat((ref4 = router.query) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.dspSid) === null || ref5 === void 0 ? void 0 : ref5.slice(0, -2), "00");
    var handleShare = function() {
        open(function(overlay) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
                baseUrl: "".concat(config_public/* default.ENV_PRODUCT_URL */.Z.ENV_PRODUCT_URL, "/product/localList.m"),
                parameter: "menu=".concat(menu, "&dspSid=").concat(pathDspSid, "&goodsCd=").concat(goodsCd),
                afterClose: function() {
                    return (0,commonUtil/* appBottomScheme */.V3)(false);
                }
            }));
        });
    };
    if (productDetailFetch.isFetching || productDetailFetch.isError || !eventsInCalendar || !availEventData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        title: "출발일 보기",
        size: "full",
        animate: "slideIn",
        padding: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* ContentWrap */.Xs, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_EventListInfo, {
                    goodsCd: goodsCd,
                    productDetail: productDetail,
                    handleShare: handleShare
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventlistFilters, {
                    goodsCd: productDetail.goodsCd,
                    removeAllFilters: removeAllFilters,
                    removeFilter: removeFilter,
                    option: option,
                    productDetail: productDetail,
                    openTrafficPopup: openTrafficPopup,
                    openOptionPopup: openOptionPopup
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                    logMsg: "DeparetureDayPopup SelectDepartureDate Error",
                    children: currentMonth && /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Area */.uN, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* TitleWrap */.BV, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_text/* SubTitle */.DK, {
                                        children: "출발일 선택"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopupM/* ReservationBox */.me, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ReservationText */._9, {
                                                state: "possible",
                                                children: "예약가능"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ReservationText */._9, {
                                                state: "waiting",
                                                children: "예약대기"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopupM/* ReservationText */._9, {
                                                state: "deadline",
                                                children: "예약마감"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_EventListCalendar, {
                                value: currentMonth,
                                data: eventsInCalendar,
                                minDate: minDate,
                                maxDate: maxDate,
                                onDateChange: onDateChange,
                                onMonthChange: onMonthChange,
                                ref: calendarRef
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_SelectSchedule, {
                    eventsInCalendar: eventsInCalendar,
                    currentDate: currentDate
                })
            ]
        })
    }));
};
/* harmony default export */ var mobile_EventListPopup = (EventListPopup);


/***/ }),

/***/ 71392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);


/**
 * useCountdown
 * @param {Dayjs} targetDate - 목표 시간
 * @returns {string | null} - 남은 시간 "(dd일) hh:mm:ss" 형식 또는 null
 */ var useCountdown = function(targetDate) {
    if (!dayjs__WEBPACK_IMPORTED_MODULE_1___default().isDayjs(targetDate)) return null;
    var calculateTimeLeft = function() {
        var now = dayjs__WEBPACK_IMPORTED_MODULE_1___default()();
        var diff = targetDate.diff(now);
        if (diff <= 0) return null; // 목표 시간이 지나면 null 반환
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(diff % (1000 * 60) / 1000);
        return "".concat(days > 0 ? "".concat(days, "일 ") : "").concat(hours >= 10 ? hours : "0".concat(hours), ":").concat(minutes >= 10 ? minutes : "0".concat(minutes), ":").concat(seconds >= 10 ? seconds : "0".concat(seconds));
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(calculateTimeLeft()), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer = setInterval(function() {
            var updatedTimeLeft = calculateTimeLeft();
            if (!updatedTimeLeft) clearInterval(timer); // 목표 시간이 지나면 타이머 종료
            setTimeLeft(updatedTimeLeft);
        }, 1000);
        return function() {
            return clearInterval(timer);
        }; // 클린업
    }, [
        targetDate
    ]);
    return timeLeft;
};
/* harmony default export */ __webpack_exports__["Z"] = (useCountdown);


/***/ }),

/***/ 69530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ scrollRestore; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _COMPONENTS_provider_ScrollRestoreProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52708);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



var debounce = function(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    var timer;
    return function() {
        clearTimeout(timer);
        timer = setTimeout(function() {
            callback();
        }, timeout);
    };
};
var useScrollRestoration = function() {
    // const
    var router = useRouter();
    var scrollRestoreContext = useContext(Context);
    var restoreScroll = useRef();
    var event = useCallback(debounce(function() {
        return scrollRestoreContext.setScrollData();
    }), []);
    useEffect(function() {
        restoreScroll.current = scrollRestoreContext.getScrollData();
        window.addEventListener("scroll", event);
        return function() {
            window.removeEventListener("scroll", event);
        };
    }, [
        router
    ]);
    var setRestoreData = useCallback(function(data) {
        scrollRestoreContext.setRestoreData(data);
    }, []);
    var getRestoreData = useCallback(function() {
        return scrollRestoreContext.getRestoreData();
    }, []);
    var scrollUpdate = useCallback(function() {
        window.scrollTo(0, Number(restoreScroll.current));
    }, []);
    return {
        setRestoreData: setRestoreData,
        getRestoreData: getRestoreData,
        scrollUpdate: scrollUpdate
    };
};
var scrollRestore = function() {
    var scrollRestoreContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_COMPONENTS_provider_ScrollRestoreProvider__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._);
    var setRestoreData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(data) {
        scrollRestoreContext.setRestoreData(data);
    }, []);
    var getRestoreData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return scrollRestoreContext.getRestoreData();
    }, []);
    return {
        setRestoreData: setRestoreData,
        getRestoreData: getRestoreData
    };
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useScrollRestoration)));


/***/ }),

/***/ 28906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42277);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/selectOne`
 * parameter
 *      goodsCd: string
 * ```*/ var key = "useGlobalGoodsLive";
var getPath = function() {
    return "".concat("https://support.ybtour.co.kr", "/api/bff/link/global/selectOne");
};
/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/selectOne`
 * parameter
 *      goodsCd: string
 * ```*/ var useGlobalGoodsLive = function() {
    var goodsCd = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", options = arguments.length > 1 ? arguments[1] : void 0;
    try {
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            queryKey: [
                key,
                goodsCd,
                getPath()
            ],
            queryFn: function() {
                return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                    url: getPath(),
                    method: "GET",
                    params: {
                        goodsCd: goodsCd
                    }
                }).then(function(r) {
                    return r.data;
                });
            },
            throwOnError: false
        }, options));
    } catch (error) {
        _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(error);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalGoodsLive);



/***/ }),

/***/ 72204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, bannerContentsSSR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 콘텐츠 구분 코드 배너 목록 조회
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/ var key = "useBannerContents";
var getPath = function(diviCd) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/common/contents/").concat(diviCd);
};
/** ```
 * 콘텐츠 구분 코드 배너 목록 조회 SSR
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/ var bannerContentsSSR = function(diviCd) {
    return useConfigureAxios(getPath(diviCd));
};
/** ```
 * 콘텐츠 구분 코드 배너 목록 조회
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/ var useBannerContents = function(diviCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(diviCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(diviCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useBannerContents);



/***/ }),

/***/ 82767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품 배너 가져오기
 *   `/goods/banner/deal`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useBannerGoodsDeal";
var getPath = function() {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/banner/deal");
};
/** ```
 * 상품 배너 가져오기
 *   `/goods/banner/deal`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useBannerGoodsDeal = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(),
                params: {
                    goodsCd: goodsCd
                }
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useBannerGoodsDeal);



/***/ }),

/***/ 38307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품 옐로PICK 배너 정보 api
 *   `/pkg/goods/banner/pick`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var key = "useGoodsBannerPick";
var getPath = function() {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/banner/pick");
};
/** ```
 * 상품 옐로PICK 배너 정보 api
 *   `/pkg/goods/banner/pick`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var useGoodsBannerPick = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(),
                params: {
                    goodsCd: goodsCd
                }
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsBannerPick);



/***/ }),

/***/ 28206:
/***/ (function(module) {

module.exports = "/_next/static/images/banner_yellowpick_585.XsSoZZh6.png";

/***/ }),

/***/ 35308:
/***/ (function(module) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAABkCAYAAAAFQ+uyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDcuMi1jMDAwIDc5LjU2NmViYzViNCwgMjAyMi8wNS8wOS0wODoyNTo1NSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIzLjQgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBDM0M2NTRFMDM2MDExRUU5NDMxQjJBMDBEMzg0OEU5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBDM0M2NTRGMDM2MDExRUU5NDMxQjJBMDBEMzg0OEU5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEMzQzY1NEMwMzYwMTFFRTk0MzFCMkEwMEQzODQ4RTkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEMzQzY1NEQwMzYwMTFFRTk0MzFCMkEwMEQzODQ4RTkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Cs4D7AAARJUlEQVR42uydbXcTxxXHZT1Yki1pV8hAEii26wTngSQmhRJCGptwcmhLmzgv8jrOJ8D9BHE+AeYTQF6nPZjTJi05JdgNBBIINoTnllrGUBJsbMuWLD9Ipv8rxo5ZzaxW8mr1sDPn6EjaXa1mZ3/7v/fO3pmtcdigDA8PtzmdzlfxsenRo0dteFfZqg7NplN4Da3+XlNTM4Tf9qdSqUvNzc1TDlmKUmqq8aBGR0fbl5aWOhl0HSbuOkqgAs5+7P84wIxKhCSIT5Q7d+68B/AIvs5VilfsQlAelVDaHESY3CaYzQ8BXxeZ3RJXh6DsbWxs/FRiZRMQGYAfMwDLrUQBZI8EsopBBIAqADxUIIB3PB7PA7zuu93utMvlSgKYIF4B7C+A/aZR4tgu81pYWAgvLi7WwuyG8N6K7ZQ8/2+KKeQnErMqAnFkZOQggOkx6v9h2zs+n++83+9/BPhasIiiZmeBf78AIL9H5Hx3dnbWB0hfAWSNRhUSdfkIPmS/xK2CQaSuF5z0Q0aiX5zwkbq6uot4ufCbDrxCxYqNoJIXEomEG1C2G1FLUkfA/InsAqpAEAFhF4NQVwWheBcDgcBdmNyd+Pq0lXUE/D/Mz8/fAJRvALRNUh2rCETyBQHgEXzs1NsOft53iqKM4X0fvvpKWWcA9gAq+c3MzMwOALk5x7YE41GJXxmDyCA8hY9tom0QWIwGg8HB2tra3+JrbTnVH5BNwlwPTE9P78VXRcdUH0Ug85FEsAxBZP7gMYegTxDrHDDBX3q93p34HC73+ArqODY3N7dDZ5s+po5TEsTygvCUyB+E+b0bDod/xDY7KqmBEWn/c3Jy8tf4KAqchgDjXrvDWFMJECIKPldfX/8yPtZXaDvficViizDZLRJGgbtVBhA26UEIAL/Ga1cFQ0hli6qqT8GnPSNY38aCM4cEsXSByTERhDDFf4ca/sZRBckZULx6RPg7fD7fScEmnSMjI0ckiKXwCx6rADc6hoJ86Xa7f1dl7e1FtN8OGAcEsHbh4uyRPqK1atgDED8WQPiFx+P5fRW3ewoR9RlE1O0CIPfardO7pkQQkk80yFsXCoVOeL3e/TZoe4LxPGDczVlHd2C22yl4cZYAwmW/MNtueb1nbQIhFTfM9Isul+sGZx2luR2ykyK6S/Cf3Q5OhzWdEKjhizZzjZR169ZNjI+Px6CAitZfRPBC42WGlpaW2rQBHY2jychqKhWDcg5J05yfGlJXzTAnaHE0NDREHaXPsi6NjU6lrk1OTq7lIiQT3s/G0gxUIpiWghiNRskkZyUywESdQCS532HjMjU1dXFxcfE1k3Y3xNLOjleKn2kZiFDDDtZxrVXD0UgkQn5j0M4gwhQPjY2NNReQCa7LNwPycLkDaWWw0s1bCB/pmt0hZBdkWyAQOG3yblXKaid3CKXT9ooo8g3dbvf5cDhM5sjlkIXKA6ii18FJH0Nb3UKAklz+DpXzw7fcmuf++wHm++WojlZFzT28hYiSFySET5QNUMWT8Xh8H8ePHgOMezi/uZtOp6OJRKJ2YWHheYCmNzyig6nj3nILaCxRRAQpk9ruB4/HM6iq6nbJXlaJjY+PO7TdOX6//wog3Zbrx4DydCwWa8a73rCFKZYH2WcbH5HGnTg4SQ1o1FnJHLcoPp/vinZhMpncBnju5fqxy+V6E373Jry+xWfR9pmbCuzc2CZY6eREiDEoYptkjl/q6uq4429gem8b3Qcg3AX/O4B9ndEJkI7Q7VZbgIiDfU+7DGbmIqVFSeQEJ8XpfA2vLDWbm5tT8mx7pb6+fg+pIz5PC7Y5RcFkVYNIfYeCK94jcdNnCBfrbY4ivlrIzkgdI5HIfQGMwnv/1aSIHYKGeVmypl+8Xq9LEIxcLdAyterA2FbqPMiigEhST1OE4KA/1K5zu93fO3SGWcqyYp5f4i1PpVLja3CTWuE3XhesO1hKE+02Eb42NkUcBSc0Myt3O5iccYmZIWjU2traIZjjNo2fqEItC94vmWkKYGZnZ7V9ktSzQapYkkh6zYpIE2RGo9FTlOgK+LgpXhpFDEjMjBWPxzOhXba0tBQxISrfxuvaIQtWqii6YBApEAGAw2iYPkce0wNDNddJxAyrl5tjmjeboLZKKBSKClZXhiJShjWNNmOZNHn7FABxi0TMoN/kdvt5y2F57puw7z0iVSx7ECmDg+5VFjpTKyXAOip7fLLVfuJTAhAfmLF/gSqqpcjUMRyssIkye/W2oTsmcKS/q6+vJxNCg4O0w0Gp6yAkETMMYlEnmBIkUdD/HoLbdVCzOPOoD7xHWRZ41HIQyRTnUMEY4BsgJxif32G+zBccs3wTbzslYoZL0afaQ2R+idNR3sRzu1iPSMayAdQoG5pw2IxMHudaIaTpgdevXz8DCN/F11+uiu5SHBDdkq28FJELItrWtJ4HnL9YgT+lLjqaSHWQglZwQhG3WhQQ9SBEBWYikcjFYDBICseL5Go4V9SSxMtalypX8Xg8ZtxcICiPUvxALpypIILuXhGE8C1uAsJZujmfT2OhonWSIeMF7T8lEIG4adHq40fDmVVoaEIvFHIw3/5It050fFBwBX2tKMoruQb5uFyurK6HdDr9gsQrr7IkADFlctCSGYaAcxbHKwW/kSbDXzH/8/PzGfMNX1JdXFxszpEFTiUzkwfUscfo4z3cHAibRFOkkRICwjYjg514EZ/otp8sQkW0JHk4HA7rjn3x+/1PvKNeN5PJ5E9zc3MtepngNHALMDbBp/1TrnEyTg5ABKHKUbgbqqpuMDriDtvzKuYwkmUsy0p73bfAnBYSRLUiOH2LZYKf1skEd7CA5lSuQMapNckOzu06Sh3CVePNZ95q0a08XB3/k4gZK6lUKl3udVwemhAIBAZEybfMVOvC6NQAd0gg3ZexrjnPq2aLoHFl5GwcxKy7UNTvV451hdlub2homCZ/UwfGYzlBZANpmrQb+Hy+b4j6AupWh99d0C6k59tJxIwVBAdZDy/yer2xMq7yZrhvG3XGyXSIEnCdqxSMGyUHg8GCsz0AcZaDigisRSJmyD+8B0XcxAkYy3oc+PI4GRGMNDkrbwiJk6kh9flk9ftgZ2fxVnC2jMfjqeX4iCEzskeqvdCgeUHPRWMl1D8HjEe0/uKyInYJdvbMWiqDRmsV+D53JWr6ZW5uro4TGFB0urlSjoFyDwQ+I7mA3Vkg8oZ8Qs3+g7c1XX3Y70ZU5N/a5fF4fJNETbfdEslkcjvnxN6usONQEOjWCdYdXK2KTjZgpolz0D+aURmE9VGOIj4DE31LIicMUq7xliNQ2ViBh7M5FArxnqKgrlZFUsQOgX9nigmAIm4VmJ6YRI5foIZhnlmmjuRKPB5cQO2CbPCDq0HMUkOaZQAbNZkkz42InrOc1tnZ2a2USCuxywrmLs3Pzz/L8devVPJx6WSDdwkVEWo4aXIEtcDpnlBggoYkek+WRCLBvSFfW1v7eiUfFxRRNJNZhj8nL4sG5tRUpYLCvklTFGuXz8zMtElVfEINr8Nl4XWjnTF5SuOSBC687pzlQJkUsY1Dr9mdph5FUX7gqSL8IRm0PC5pXJhugUVprIYDFEwMoGYmZxDQa3pKP8z929jvVY4p2klpRXanEH7hBbgqz/HU0FFBfYc5AlfRBdVk5WTuvnA4zO0Hm5qaotSytI05/BFq2MoRhGk2IK1aiuiC4isiFGqhSA7ruzSBu3Y59SvCN7pgV9cQF2IcbZ6VIhUMBgcr3TfkBF3c7CGnIFiYL1ZFVFX18f4TirArnU5fsxuFuADPLy4uPssxY7eo/80mzZBRxCGOQhXtuSe4wl8OhUKnBSZ6EyC1zWxhFCXTBSi4YO00rkIlEKPapXCai/q0AZ/PdwDBywXOiVEAo1c0eq3KILw5MTHBHUxGt8Qq9S5KoYULIhTxV3iLF/USUNX1vL5FUuNYLPYTPv5U5RA+xRtMRj6UjUzycuknEPt5a+Cv3SjynzdGIpGHPH8RPlPr5OTkRDXCiOO9xCBUOMHcPahhUzUTJ5oH3Nnc3NwvcKIXi10pev5cOBzmRlFQxhdgph/i42gVQfjtw4cPG3kQsgFq8WqLkjXHLxrtN+RkGxzXrkkmk/T84KLDCF/xLUVR/sZbB2V8EepBI8OGqwHC8fHxVl43DUHIJlqvar9QlHVO7uFyP2Ifp+EUqJIlfXvwi/4QCAT+Kqj8S1CRdajPrQo+ARkIHZzx4lTYKMmqD07m5+d5F2iMZhNbAVHQt2fZ7K5+v/+PgPGcwLlXAOPGSoQRF/NZqPouEYRsgPqb1Q4hzt00ZwL5FRHMgMimg+jjNOImvM5ZCOPrNFBbcCDLMF6ulMaHa/EVgq7dovV2gZBZhR9EEXPGPVn+JnqmMpbF4L84rHSiESgdgxq/LwhwplCfm3jfVe4QIth6W3AMFJhcp0dN2KV/BhfkXe1E9MwsqyuKyFQxihWf8pQIkmqpSfT5fO8jgPlcoIwq+Vsw1/1l3EXxuR6EFJjYCUL4hgOCpyGsTIWtTXro5vmKAHEnGveklZVHAHNAVdWvBKtVmOk2CgLKEMLPYrHYAT0I7XTXhLpspqen23lBihBE5iv28HaIxt1n9YmnHEaYsLMiGCkIoGCgXNo8mUyeRDt9ICH8OUBBe4ju0PWunqouKw0MK3t5/YpU6MTDJJ6w8mDcbvduwHhOx/fYTf5Yqds8kUh8HY/H90kIfy64MC/TXTIOoCOr1ZALIitdbOOsApO4n3wgi2F8nZ45LBrfQv6Y1XVa3blAEMJ9eUtC+IQ7dxrtIuoR6NJO3MkFkW3UKTrx5AOB9r9QgGvVgZFzv2HDhqt6dQKMx632w6GCAyIIKaeQpmqzmznWgxDrD/NuK+ume7HJmfpFXTcIKM4Hg8F1TqezxcIDHUTUTP/HnccZ0fZnqNcHFlQlASf8NCLC/SIIaYq2ar53zAtMyCfkmWO2nh4U1MG1HLl2ngtGKoDxzzj52wDk8xYd8BW4CFtEk4oHAoGTfr//bSPHVyiEaPB+KPABCeFKb0H/zMzMdroLJjhnlNzSIZpL29CJMgIjuWr19fVf+Hy+JgD5hgUw3gSMT4tgrKur+xfqQ/Vwm/y/McqXxFW/VUKYuWNyGpahSe+pqbkgdOSjGGyypj40cM6JxOHP/QMqOYmT8hy231GsRsDV919EzQ005yJvPVTxJNSx3UQYxyg1DRA+b2cI6Z4/FPA+fMGWXI/tZTdJunM9VSBv00VTz9Ksn3kEGaMej+ceXg+hlAF8T+C9ARX0mtQokxMTE6TYqg6M5Div9f9GAeEMpabxVuKYYojsb6A+vmoDD7BlpqCBP6wCwGaR+eWcm08AYI+RbQvyoZip7gWQFZHS7vV6T4RCIYKx0Ef0jlJeJKWkOWQxAuAl1kVjeG6jNTnzbCYnUsiynxIDwdTngHEP6prvgwtvA8I5CaEx/5l4oJsi+f7WlKiSTc7dzZt5tpwK3IMbiqI8nYcPdx0BURqmaJvETBdAuvlBJrgvly9YVBBXAUlqQyrZWa5mm2BEQBHBx/U5GveyaHyJLCvw9Tse3zNe8/SCRR2/zHzJDhZIdKxapRqJvosI4zXASJMI/EIHwi288SU2hC3KvpLSDbHv/WY/wb6mmhsSFwI9Q/hDQTR/FVEuRbgtmsankXatIgjZLapuqYnmlppqP0A9GJ1O55VIJOJfhpGSbSnP0SHoCgKEHwHCoxIbCWKxYHQhKh5GdPyGhFCCWEoYY1DDRxJCCWLJYdRx2CWEFhSnnQ4WQFHC72EJoVTEclFGeqr6ER0A6Q4B3aLqk4hIEEsCI4Oww4xOWlkkiAXBKCGUIJYURsfjEWWZcToSwtKU/wswAD57dzGzjeHkAAAAAElFTkSuQmCC"

/***/ })

}]);